var app = new function(){
	this.modules = {};
	this.settings = {};
	this.vars = {
		screenMobile:true,
		screenMobileLandscape:false,
		screenTablet:false,
		screenTabletLandscape:false,
		screenDesktop:false,
		screenWide:false,
		screenFull:false,
		breakPoint:'mobile',
		isTouchDevice:false,
		ieVersion:false
	};
	this.init = function(){
		var that = this;

		// extend jquery
		jQuery.extend({
			getQueryParameters:function(str){
				return (str || document.location.search).replace(/(^\?)/,'').split("&").map(function(n){
					return n = n.split("="), (!this[n[0]] ? this[n[0]] = n[1] : ((typeof this[n[0]] === 'object') ? this[n[0]].push(n[1]) : this[n[0]]=[this[n[0]], n[1]])), this
				}.bind({}))[0];
			},
			getQueryParametersWithoutUrlQuery:function(str){
				return str.replace(/(^\?)/,'').split("&").map(function(n){
					return n = n.split("="), (!this[n[0]] ? this[n[0]] = n[1] : ((typeof this[n[0]] === 'object') ? this[n[0]].push(n[1]) : this[n[0]]=[this[n[0]], n[1]])), this
				}.bind({}))[0];
			},
			isInViewport:function(obj){
				var elementTop = obj.offset().top;
				var elementBottom = elementTop+obj.outerHeight();
				var viewportTop = $(window).scrollTop();
				var viewportBottom = viewportTop+$(window).height();
				return elementBottom > viewportTop && elementTop < viewportBottom;
			}
		});
		jQuery.extend(jQuery.expr[':'],{
			opacity0:function(a){
				return jQuery(a).css('opacity') == 0;
			}
		});
		jQuery.extend(jQuery.expr[':'],{
			reallyvisible:function(a){
				return !(jQuery(a).is(':hidden') || jQuery(a).parents(':hidden').length || jQuery(a).parents(':opacity0').length);
			}
		});
		$.expr[':'].containsCaseSensitive = $.expr.createPseudo(function(arg){
			return function(elem){
				return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
			};
		});
		jQuery.extend(jQuery.expr[':'],{
			data:$.expr.createPseudo ? $.expr.createPseudo(function(dataName){
				return function(elem){
					return !!$.data(elem, dataName);
				};
			}) : function(elem, i, match){
				return !!$.data(elem, match[3]);
			}
		});

		// add x-csfr-token globally
		$.ajaxSetup({
			headers:{
				'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content')
			}
		});
		
		this.setBreakPoint();
		this.resize();
		this.detectTouchDevice();
		var context = this;
		that.vars.ieVersion = that.msieversion();
		$.each(this.modules, function(index, element){
			if (typeof element.init === 'function'){
				element.init();
			}
		});
		this.parse($('body'));
		$(window).bind('load', function(){
			$.each(that.modules, function(index, element){
				if (typeof element.onLoad === 'function'){
					element.onLoad();
				}
			});
		});
	};
	this.parse = function($context){
		$.each(this.modules, function(index, element){
			if (typeof element.parse === 'function'){
				element.parse($context);
			}
		});
	};
	this.resize = function($context){
		var that = this;
		$(window).resize(function(){
			if (that.vars.isTouchDevice == false){
				that.setBreakPoint();
			}
		});
		$(window).on('orientationchange', function(event){
			that.setBreakPoint();
		});
		$.each(this.modules, function(index, element){
			if (typeof element.resize === 'function'){
				$(window).resize(function(){
					if (that.vars.isTouchDevice == false){
						element.resize();
					}
				});
				$(window).on('orientationchange', function(event){
					element.resize(event.orientation);
				});
			}
		});
		$(window).trigger('resize');
	};
	this.detectTouchDevice = function(){
		try {
			document.createEvent('TouchEvent');
			app.vars.isTouchDevice = true;
		} catch(e){
			app.vars.isTouchDevice = false;
		}
	};
	this.getViewport = function(type){
		var viewPortWidth;
		var viewPortHeight;
		if (typeof window.innerWidth != 'undefined'){
			viewPortWidth = window.innerWidth,
			viewPortHeight = window.innerHeight
		} else if (typeof document.documentElement != 'undefined' && typeof document.documentElement.clientWidth != 'undefined' && document.documentElement.clientWidth != 0){
			viewPortWidth = document.documentElement.clientWidth,
			viewPortHeight = document.documentElement.clientHeight
		} else {
			viewPortWidth = document.getElementsByTagName('body')[0].clientWidth,
			viewPortHeight = document.getElementsByTagName('body')[0].clientHeight
		}
		if (type == 'width'){
			return viewPortWidth;
		} else {
			return viewPortHeight;
		}
	};
	this.reinit = function($context){
		$.each(this.modules, function(index, element){
			if (typeof element.reinit === 'function'){
				element.reinit();
			}
		});
	};
	this.setBreakPoint = function(){
		var that = this;
		var windowWidth = that.getViewport('width');
		var breakPoint = 'mobile';
		app.vars.screenMobileLandscape = false;
		app.vars.screenTablet = false;
		app.vars.screenTabletLandscape = false;
		app.vars.screenDesktop = false;
		app.vars.screenWide = false;
		app.vars.screenFull = false;
		if (windowWidth >= 480){
			breakPoint = 'mobileLandscape';
			app.vars.screenMobileLandscape = true;
		}
		if (windowWidth >= 768){
			breakPoint = 'tablet';
			app.vars.screenTablet = true;
		}
		if (windowWidth >= 1024){
			breakPoint = 'tabletLandscape';
			app.vars.screenTabletLandscape = true;
		}
		if (windowWidth >= 1224){
			breakPoint = 'desktop';
			app.vars.screenDesktop = true;
		}
		if (windowWidth >= 1324){
			breakPoint = 'wide';app.vars.screenWide = true;
		}
		if (windowWidth >= 1600){
			breakPoint = 'full';
			app.vars.screenFull = true;
		}
		if (breakPoint != that.vars.breakPoint){
			that.vars.breakPoint = breakPoint;
		}
	};
	this.msieversion = function(){
		var ua = window.navigator.userAgent;
		var msie = ua.indexOf("MSIE ");
		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)){
			return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
		} else {
			return false;
		}
	};
	this.fixedContent = function(type){
		var htmlBody = $('html,body');
		var currentScrollTop = $(window).scrollTop();
		if (type == true && !htmlBody.hasClass('fixed')){
			htmlBody.addClass('fixed');
			$('.site').css({
				marginTop:currentScrollTop*-1
			});
			htmlBody.scrollTop(0);
		} else {
			var newScrollTop = parseInt($('.site').css('margin-top'));
			$('.site').attr('style','');
			htmlBody.removeClass('fixed');
			htmlBody.scrollTop(newScrollTop*-1);
		}
	};
	this.getQueryString = function(obj){
		var that = this;
		var queryParams = $.getQueryParameters();
		if (typeof obj !== 'undefined'){
			$.each(obj, function(key, value){
				if (key != ''){
					queryParams[key] = value;
				}
			});
		}
		var result = $.param(queryParams);
		return result;
	};
	this.debounce = function(func, wait, immediate){
		var timeout;
		return function(){
			var context = this, args = arguments;
			var later = function(){
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};
	this.elementOrParentIsFixed = function(element){
		var element = $(element);
		var checkElements = element.add(element.parents());
		var isFixed = false;
		checkElements.each(function(){
			if ($(this).css('position') === 'fixed'){
				isFixed = true;
				return false;
			}
		});
		return isFixed;
	};
	this.canUseWebP = function(){
		var elem = document.createElement('canvas');
		if (!!(elem.getContext && elem.getContext('2d'))){
			return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
		}
		return false;
	};
	this.isJsonString = function(string){
		var that = this;
		if (/^[\],:{}\s]*$/.test(string.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))){
			return true;
		} else {
			return false;
		}
	};
};
var baseBegin = true;
$(function(){
	if (typeof $('.onepager-tile').html() !== 'undefined'){
		app.modules.onepager.init();
	} else {
		app.init();
	}
});
var baseEnd = true;
function form(){
	this.vars = {
		loading:false,
		attemptedRequest:null,
		autocompleteOffValue:typeof $.browser !== 'undefined' && $.browser.chrome ? 'nope' : 'off'
	}
}
form.prototype = {
	init:function(){
		var that = this;
		that.addListener();
		that.formValidation();

		// form field dependency
		if (jQuery().formFieldDependency){
			$('[data-depends]').formFieldDependency();
		}

		// tags input
		$('[data-tags]').each(function(){
			var tagsInput = $(this);
			var tagsOptions = {
				delimiter:',',
				persist:false,
				create:function(input){
					return {
						value:input,
						text:input
					}
				}
			};
			if (tagsInput.attr('size') !== 'undefined'){
				tagsOptions.maxItems = tagsInput.attr('size');
			}
			tagsInput.selectize(tagsOptions);
		});

		// select
		that.initSelectize();

		// init repeatable
		$('[data-repeater]').each(function(){
			var repeatable = $(this);
			repeatable.repeatable();
		});

		// colorpicker
		$('[data-colorpicker]').each(function(){
			var colorpicker = $(this);
			colorpicker.spectrum({
				preferredFormat:'hex',
				showInput:true,
				chooseText:typeof window['translations']['choose'] !== 'undefined' ? window['translations']['choose'] : 'choose',
				cancelText:typeof window['translations']['cancel'] !== 'undefined' ? window['translations']['cancel'] : 'cancel'
			}).on('show.spectrum', function(e, tinycolor){
				var replacer = $(e.target).next();
				var replacerOffsetTop = replacer.offset().top;
				var container = $(colorpicker.spectrum('container'));
				var containerOffsetTop = container.offset().top;
				if (containerOffsetTop < replacerOffsetTop){
					container.addClass('sp-container-top').removeClass('sp-container-bottom');
				} else {
					container.removeClass('sp-container-top').addClass('sp-container-bottom');
				}

			});
		});

		// submit three-d-secure loading form
		$('.form--loading-three-d-secure').submit();

		// detect form changes
		if (jQuery().dirtyForms){
			$('.form--dirty').dirtyForms({
				//
			});
			$('.form--dirty:not(.form--dirty-no-clean)').on('dirty.dirtyforms clean.dirtyforms', function(ev){
				var form = $(ev.target);
		        var submitResetButtons = form.find('[type="reset"], [type="submit"]');
		        if (typeof submitResetButtons.html() === 'undefined'){
		        	submitResetButtons = $('[type="reset"][form="'+form.attr('id')+'"], [type="submit"][form="'+form.attr('id')+'"]');
		        }
		        if (ev.type === 'dirty') {
		            submitResetButtons.removeAttr('disabled').removeClass('button--white button--disabled');
		        } else {
		            submitResetButtons.attr('disabled', 'disabled').addClass('button--white button--disabled');
		        }
		    });
		}
	},
	addListener:function(){
		var that = this;

		// limit checkbox group
		$('input[type="checkbox"][data-limit]').on({
			change:function(){
				var checkbox = $(this);
				var checkboxLimit = parseInt(checkbox.attr('data-limit'));
				if ($('[name="'+checkbox.attr('name')+'"]:checked').length > checkboxLimit){
					this.checked = false;
				}
			}
		});

		// ajax button
		$('.button--ajax').unbind().on({
			click:function(){
				that.submitAjaxButton($(this));
				return false;
			}
		});

		// remove media button value
		$('.fileuploader-theme-onebutton .close').unbind().on({
			click:function(){
				var removeButton = $(this);
				var fileuploader = removeButton.closest('.fileuploader');
				var fileuploaderField = fileuploader.find('input[type="file"]');
				fileuploader.find('.button').removeClass('button--bordercolor-error button--color-error button--bordercolor-primary button--color-primary button--disabled').html('<span class="icon icon--inline-left icon--arrow-top2"></span>'+removeButton.parent().attr('data-default-text'));
				fileuploader.next().val('');
				var api = $.fileuploader.getInstance(fileuploaderField);
				api.reset();
				var fieldId = removeButton.parent().prev().attr('id');
				if (jQuery().dirtyForms){
					$('.form--dirty').dirtyForms('rescan');
				}
				return false;
			}
		});
	},
	submitAjaxButton:function(button){
		var that = this;
		if (!button.hasClass('button--disabled')){
			button.attr('href', button.attr('data-href') !== 'undefined' ? button.attr('data-href') : button.attr('href'));
			if (typeof button.find('.icon').html() !== 'undefined' && button.find('.icon').is(':last-child')){
				button.find('.icon').addClass('hidden');
			}
			button.addClass('button--disabled').append('<span class="loader"></div>');
			if (button.attr('href').substring(0, 3) == 'js_'){
				var jsCallbackArr = button.attr('href').replace('js_', '').split('.');
				button.removeClass('button--disabled');
				button.find('.loader').remove();
				button.find('.icon').removeClass('hidden');
				app.modules[jsCallbackArr[0]][jsCallbackArr[1]](button);
			} else {
				if (typeof button.attr('data-redirect') !== 'undefined' && button.attr('data-redirect') == '1'){
					window.location.href = button.attr('href');
				} else {
					$.ajax({
						type:typeof button.attr('data-type') !== 'undefined' ? button.attr('data-type') : 'POST',
						url:button.attr('href'),
						data:typeof button.attr('data-data') !== 'undefined' ? button.attr('data-data') : null,
						error:function(jqXHR, exception){
							that.vars.attemptedRequest = button;
							if (jqXHR.status == 403){
								app.modules.overlay.hideIfOpen();
								setTimeout(function(){
									app.modules.overlay.show('inline', 'not-authorized', undefined, true);
								}, 310);
							}
							if (jqXHR.status == 419){
								app.modules.overlay.hideIfOpen();
								setTimeout(function(){
									app.modules.overlay.show('inline', 'session-expired', undefined, true);
								}, 310);
							}
							if (jqXHR.status == 401 || jqXHR.status == 403 || jqXHR.status == 419){
								button.removeClass('button--disabled');
								button.find('.loader').remove();
								button.find('.icon').removeClass('hidden');
							}
						},
						success:function(data){
							if (data.success !== true){
								button.removeClass('button--disabled');
								button.find('.loader').remove();
								button.find('.icon').attr('class', 'icon icon--warning icon--color-error');
								that.throwErrorMessage(button, data.error, true);
							} else {
								if (typeof button.attr('data-return') !== 'undefined' && typeof data[button.attr('data-return')] !== 'undefined'){
									button.removeClass('button--disabled').html(data[button.attr('data-return')]);
								} else if (typeof data.button !== 'undefined'){
									button.removeClass('button--disabled').html(data.button);
								} else if (typeof data.redirect !== 'undefined'){
									if (typeof data.clearButton !== 'undefined' && data.clearButton){
										button.removeClass('button--disabled');
										button.find('.loader').remove();
										button.find('.icon').removeClass('hidden');
									}
									window.location.href = data.redirect;
								} else {
									button.removeClass('button--disabled');
									button.find('.loader').remove();
									button.find('.icon').removeClass('hidden');
								}
								if (typeof data.callbackJs !== 'undefined'){
									if ($.isArray(data.callbackJs[0])){
										$.each(data.callbackJs, function(key, value){
											if (typeof app.modules[value[0]] !== 'undefined'){
												app.modules[value[0]][value[1]](button, data);
											}
										});
									} else {
										app.modules[data.callbackJs[0]][data.callbackJs[1]](button, data);
									}
								}
								if (typeof data.msg !== 'undefined'){
									$.toaster({
										priority:'success',
										message:data.msg
									});
								}
							}
						}
					});
				}
			}
		}
	},
	formValidation:function(){
		var that = this;
		if (jQuery().validate){
			$('form:not(.form--no-validate)').each(function(){
				var formObj = $(this);
				formObj.validate({
					rules:window['rules_'+formObj.attr('name')],
					messages:window['messages_'+formObj.attr('name')],
					ignore:'.fr-box *, .jodit_container *, :hidden:not([class~=selectized]), :hidden > .selectized, .selectize-control .selectize-input input',
					lang:$('html').attr('lang'),
					invalidHandler:function(event, validator){
						that.throwError(formObj, validator.invalid);
					},
					errorPlacement:function(error, element){
						if (element.attr('type') == 'checkbox'){
							element.parent().parent().find('.checkbox__description').append(error);
						} else if (element.attr('type') == 'radio'){
							error.insertAfter(element.parent().parent().parent());
						} else if (element.is('select') || typeof element.attr('data-tags') !== 'undefined'){
							error.insertAfter(element.next());
						} else if (element.attr('type') == 'select-multiple' || element.attr('type') == 'select-one'){
							element.parent().parent().parent().append(error);
						} else if (typeof element.attr('data-captcha-input') !== 'undefined') {
							element.parent().parent().append(error);
						} else {
							error.insertAfter(element);
						}
					},
					submitHandler:function(form){
						if (that.vars.loading == false){
							if (typeof formObj.find('[name="callbackModule"]').val() !== 'undefined' && formObj.find('[name="callbackModule"]').val() != '' && typeof formObj.find('[name="callbackFunctionBeforeSubmit"]').val() !== 'undefined' && formObj.find('[name="callbackFunctionBeforeSubmit"]').val() != ''){
								var callbackModule = formObj.find('[name="callbackModule"]').val();
								var callbackFunctionBeforeSubmit = formObj.find('[name="callbackFunctionBeforeSubmit"]').val();
								app.modules[callbackModule][callbackFunctionBeforeSubmit](formObj, form);
							} else {
								that.submit(formObj, form);
							}
						}
					}
				});
			});
		}
	},
	submit:function(formObj, form){
		var that = this;
		that.vars.loading = true;
		if (formObj.hasClass('form--ajax')){
			that.ajaxSubmit(formObj);
		} else {
			that.vars.loading = false;
			formObj.validate().destroy();
			setTimeout(function(){
				formObj.find('button[type="submit"]').trigger('click');
			}, 100);
		}
	},
	ajaxSubmit:function(form){
		var that = this;
		var data = form.serialize();
		if (typeof form.find('[data-google-recaptcha-v3]').html() !== 'undefined'){
        	data['g-recaptcha-response'] = getReCaptchaV3Response(form.find('[data-google-recaptcha-v3]').attr('id'));
        }
		that.loading(form, true, true, data);
		$.ajax({
			type:'POST',
			url:form.attr('action'),
			data:data,
			error:function(jqXHR, exception, thrownError){
				that.throwError(form, typeof jqXHR.responseJSON.errors !== 'undefined' ? jqXHR.responseJSON.errors : {error:jqXHR.responseJSON.message});
				that.loading(form, false, true);
			},
			success:function(data, textStatus, xhr){
				if (data.success === true){
					if (typeof form.find('[data-google-recaptcha-v3]').html() !== 'undefined'){
			        	refreshReCaptchaV3(form.find('[data-google-recaptcha-v3]').attr('id'), 'homepage');
			        }
					if (jQuery().dirtyForms){
						form.dirtyForms('setClean');
					}
					if (that.vars.attemptedRequest !== null){
						var attemptedRequest = that.vars.attemptedRequest;
						app.modules.overlay.hideIfOpen();
						setTimeout(function(){
							attemptedRequest.trigger('click');
						}, 310);
					} else if (typeof data.redirect !== 'undefined'){
						window.location.href = data.redirect;
					} else {
						if (typeof form.find('[name="callbackModule"]').val() !== 'undefined' && form.find('[name="callbackModule"]').val() != '' && typeof form.find('[name="callbackFunction"]').val() !== 'undefined' && form.find('[name="callbackFunction"]').val() != ''){
							var callbackModule = form.find('[name="callbackModule"]').val();
							var callbackFunction = form.find('[name="callbackFunction"]').val();
							app.modules[callbackModule][callbackFunction](form, data);
							if (typeof form.find('[name="callbackSuccess"]').val() !== 'undefined' && (form.find('[name="callbackSuccess"]').val() == 'true' || form.find('[name="callbackSuccess"]').val() == 1)){
								that.success(form, data, form.find('[name="responseTemplate"]').html() !== 'undefined' && form.find('[name="responseTemplate"]').val() == 'toaster' ? true : false);
							}
						} else if (typeof data.callbackJs !== 'undefined'){
							if ($.isArray(data.callbackJs[0])){
								$.each(data.callbackJs, function(key, value){
									if (typeof app.modules[value[0]] !== 'undefined'){
										app.modules[value[0]][value[1]](form, data);
									}
								});
							} else {
								app.modules[data.callbackJs[0]][data.callbackJs[1]](form, data);
							}
						} else {
							that.success(form, data, form.find('[name="responseTemplate"]').html() !== 'undefined' && form.find('[name="responseTemplate"]').val() == 'toaster' ? true : false);
						}
						that.loading(form, false, true);
					}
				} else {
					if (typeof data.error !== 'undefined'){
						if (typeof data.callbackErrorJs !== 'undefined'){
							if ($.isArray(data.callbackErrorJs[0])){
								$.each(data.callbackErrorJs, function(key, value){
									if (typeof app.modules[value[0]] !== 'undefined'){
										app.modules[value[0]][value[1]](form, data);
									}
								});
							} else {
								app.modules[data.callbackErrorJs[0]][data.callbackErrorJs[1]](form, data);
							}
						}
						that.throwError(form, data.error);
					} else {
						if (typeof window['messages_'+form.attr('name')]['error'] !== 'undefined'){
							that.throwError(form, {error:window['messages_'+form.attr('name')]['error']});
						} else {
							that.throwError(form, {error:'Error!'});
						}
					}
					that.loading(form, false, true);
				}
			}
		});
	},
	throwError:function(form, error){
		var that = this;
		var alertSuccessFormRow = $('.alert--success:not(.alert--keep)').closest('.form__row');
		$('.alert--success:not(.alert--keep)').remove();
		alertSuccessFormRow.remove();
		if (typeof form.find('[data-google-recaptcha-v3]').html() !== 'undefined'){
        	refreshReCaptchaV3(form.find('[data-google-recaptcha-v3]').attr('id'), 'homepage');
        }
		if (typeof form.find('[name="callbackModule"]').val() !== 'undefined' && form.find('[name="callbackModule"]').val() != '' && typeof form.find('[name="callbackFunctionError"]').val() !== 'undefined' && form.find('[name="callbackFunctionError"]').val() != ''){
			var callbackModule = form.find('[name="callbackModule"]').val();
			var callbackFunctionError = form.find('[name="callbackFunctionError"]').val();
			app.modules[callbackModule][callbackFunctionError](form, error);
		} else {
			that.throwErrorMessage(form, error, form.find('[name="responseTemplate"]').html() !== 'undefined' && form.find('[name="responseTemplate"]').val() == 'toaster' ? true : false);
		}
	},
	throwErrorMessage:function(form, error, toaster){
		var that = this;
		var alertFormRow = $('.alert--error:not(.alert--keep), .alert--success:not(.alert--keep)').closest('.form__row');
		$('.alert--error:not(.alert--keep), .alert--success:not(.alert--keep)').remove();
		alertFormRow.remove();
		if ($(window).scrollTop() > form.offset().top || toaster){
			var messagesHtml = '<ul>';
			var messageContainer = form.find('.alert--error');
			$.each(error, function(index, message){
				messagesHtml += '<li>'+message+'</li>';
			});
			messagesHtml += '</ul>';
			messageContainer.html(messagesHtml);
			$.toaster({
				priority:'error',
				message:messagesHtml
			});
		} else {
			var messagesHtml = '<div class="form__row form__row--msg"><div class="alert alert--error"><div class="close close--small"></div><ul>';
			$.each(error, function(index, message){
				messagesHtml += '<li>'+message+'</li>';
			});
			messagesHtml += '</ul></div></div>';
			form.prepend(messagesHtml);
			app.modules.alert.addListener();
		}
	},
	success:function(form, data, toaster){
		var that = this;
		if (data.msg){
			var message = data.msg;
		} else {
			location.reload();
		}
		if (data.resetForm){
			form[0].reset();
		}
		var alertFormRow = $('.alert--error, .alert--success').closest('.form__row');
		$('.alert--error, .alert--success').remove();
		alertFormRow.remove();
		if ($(window).scrollTop() > form.offset().top || toaster){
			$.toaster({
				priority:'success',
				message:message
			});
		} else {
			form.prepend('<div class="form__row form__row--msg"><div class="alert alert--success"><div class="close close--small"></div><p>'+message+'</p></div></div>');
		}
		app.modules.alert.addListener();
	},
	loading:function(form, type, disable, data){
		var that = this;
		var dataObj = typeof data !== 'undefined' ? $.getQueryParameters(data) : {};
		var submitButton = form.find(typeof dataObj.action !== 'undefined' ? 'button[type="submit"][value="'+dataObj.action+'"].button' : 'button[type="submit"].button');
		if (typeof submitButton.html() === 'undefined'){
			submitButton = $(typeof dataObj.action !== 'undefined' ? 'button[type="submit"][form="'+form.attr('id')+'"][value="'+dataObj.action+'"].button' : 'button[type="submit"][form="'+form.attr('id')+'"].button');
		}

		if (type){
			form.addClass('form--loading');
			if (disable){
				form.find('fieldset, .fieldset').attr('disabled', 'disabled');
			}
			if (submitButton.find('.loader').length == 0){
				submitButton.append('<span class="loader"></div>');
			}
			submitButton.contents().filter(function(){
				return this.nodeType === 3;
			}).wrap('<span class="button__loading_text"></span>');
		} else {
			that.vars.loading = false;
			form.removeClass('form--loading');
			if (disable){
				form.find('fieldset, .fieldset').removeAttr('disabled');
			}
			submitButton.find('.loader').remove();
			submitButton.find('.button__loading_text').contents().unwrap();
		}
	},
	initSelectize:function(){
		var that = this;
		$('select:not(.selectized)').each(function(){
			var select = $(this);
			var render = {
				option:function(data, escape){
					var before = '';
					var after = '';
					if (typeof data.before !== 'undefined'){
						before += '<span class="before">';
						$.each(data.before, function(key, value){
							before += '<span class="before__col"><span class="'+value.class+'">';
							before += value.text;
							before += '</span></span>';
						});
						before += '</span>';
					}
					if (typeof data.after !== 'undefined'){
						after += '<span class="after">';
						$.each(data.after, function(key, value){
							after += '<span class="after__col"><span class="'+value.class+'">';
							after += value.text;
							after += '</span></span>';
						});
						after += '</span>';
					}
					return '<div class="option">'+before+escape(typeof data.text !== 'undefined' ? data.text : data.name)+after+'</div>';
				},
				item:function(data, escape){
					var before = '';
					var after = '';
					if (typeof data.before !== 'undefined'){
						before += '<span class="before">';
						$.each(data.before, function(key, value){
							before += '<span class="before__col"><span class="'+value.class+'">';
							before += value.text;
							before += '</span></span>';
						});
						before += '</span>';
					}
					if (typeof data.after !== 'undefined'){
						after += '<span class="after">';
						$.each(data.after, function(key, value){
							after += '<span class="after__col"><span class="'+value.class+'">';
							after += value.text;
							after += '</span></span>';
						});
						after += '</span>';
					}
					return '<div class="item">'+before+escape(typeof data.text !== 'undefined' ? data.text : data.name)+after+'</div>';
				}
			};
			var selectOptions = {
				render:render
			};
			if (typeof select.attr('data-url') !== 'undefined'){
				var totalCount, page, perPage = 25;
				selectOptions = {
				    plugins:['infinite_scroll'],
				    valueField:'id',
				    labelField:'name',
				    searchField:'name',
				    options:[],
				    render:render,
				    load:function(query, callback){
				        if (!query.length) return callback();
				        query = JSON.parse(query);
				        page = query.page || 1;
						if (!totalCount || totalCount > ((page-1)*perPage)){
							$.ajax({
								type:'POST',
								url:select.attr('data-url'),
								data:'q='+query.search+'&page='+page,
								error:function(){
									callback();
								},
								success:function(data){
									totalCount = data.total;
									callback(data.data);
								}
							});
						} else {
							callback();
						}
				    }
				};
			}
			selectOptions.create = false;
			if (select.attr('size') !== 'undefined'){
				selectOptions.maxItems = select.attr('size');
			}
			if (select.closest('.sidebar__fields').length == 0){
				select.selectize(selectOptions);
				if (typeof select.attr('data-callback-on-change') !== 'undefined'){
					select.on('change', function(value){
						var callbackArr = select.attr('data-callback-on-change').split('.');
						app.modules[callbackArr[0]][callbackArr[1]](select);
						if (select.hasClass('error')){
							var form = select.closest('form');
							form.valid();
						}
					});
				} else {
					select.on('change', function(value){
						if (select.hasClass('error')){
							var form = select.closest('form');
							form.valid();
						}
					});
				}
			}
			$('.selectize-control').find('input').attr('autocomplete', that.vars.autocompleteOffValue);
		});
	},
	resetCaptcha:function(form, data){
		var that = this;
		if (!form.is('form')){
			form = form.closest('form');
		}
		var captchaField = form.find('[data-captcha-field]');
		var captchaImage = captchaField.find('[data-captcha-image]');
		var captchaInput = captchaField.find('input');
		captchaImage.attr('src', data.captcha);
		captchaInput.val('');
	},
	addListItem:function(button, data){
		var that = this;
		var listItemWrapper = button.parent().find('.panel__blocks');
		button.parent().find('.panel__blocks_empty').addClass('hidden');
		listItemWrapper.append(data.html).removeClass('empty');
		app.reinit();
	},
	reinit:function(){
		this.init();
	}
};
app.modules.form = new form;
function dashboard(){
	this.body = $('body');
	this.nav = $('.dashboard__nav');
	this.tabsTabbing = $('.tabs--tabbing');
	this.burger = $('.dashboard__nav_burger');
	this.closeMobileNavIcon = $('.dashboard__nav_close');
	this.vars = {
		canHideNav:true,
		canChangeNaviScollState:true
	}
}
dashboard.prototype = {
	init:function(){
		var that = this;
		that.addListener();

		// sticky sidebar
		if (app.vars.screenTabletLandscape){
			$('.dashboard__nav_container').stickySidebar({
				topSpacing:30,
				bottomSpacing:0,
				containerSelector:'.dashboard',
				innerWrapperSelector:'.dashboard__nav_wrapper'
			});
		}

		// sticky menu
		if (app.vars.screenTabletLandscape){
			$('.panel__nav_container').stickySidebar({
				topSpacing:20,
				bottomSpacing:0,
				containerSelector:'.panel__body',
				innerWrapperSelector:'.panel__nav_wrapper'
			});
		}

		// init nav
		that.initNav();

		// mobile menu
		that.burger.unbind().on({
			click:function(){
				if (that.body.hasClass('open-nav')){
					that.closeMobileNav();
				} else {
					that.openMobileNav();
				}
			}
		});
		that.closeMobileNavIcon.unbind().on({
			click:function(){
				that.closeMobileNav();
			}
		});

		// init tabs
		that.tabsTabbing.tabbing({
			enableNav:true,
			disableInactive:false
		});

		// sidbar nav active anchor
		var lastId,
			topMenu = $('[data-anchor-nav]'),
			menuItems = topMenu.find('a'),
			scrollItems = menuItems.map(function(){
				var item = $('[data-section][name="'+($(this).attr('href').replace('#', ''))+'"]');
				if (item.length){
					return item;
				}
			});
		$(window).scroll(function(){
			var fromTop = $(this).scrollTop();
			var cur = scrollItems.map(function(){
				if ($(this).offset().top-1 < fromTop){
					return this;
				}
			});
			cur = cur[cur.length-1];
			var id = cur && cur.length ? cur[0].name : '';
			if (lastId !== id){
				lastId = id;
				menuItems.parent().removeClass('active').end().filter('[href="#'+id+'"]').parent().addClass('active');
			}
		});
	},
	addListener:function(){
		var that = this;
		var filterListForm = $('form[name="filter_list"]');

		// filter list options
		filterListForm.find('.filter__row input[type="checkbox"]').on({
			change:function(){
				var checker = $(this);
				var filterForm = checker.closest('.filter__row');
				if (filterForm.next().hasClass('filter__item')){
					if (filterForm.next().hasClass('filter__item--open')){
						filterForm.next().removeClass('filter__item--open');
						filterForm.next().find('input, select').attr('disabled', 'disabled');
					} else {
						filterForm.next().addClass('filter__item--open');
						filterForm.next().find('input, select').removeAttr('disabled');
					}
				}
			}
		});

		// submit filter
		filterListForm.unbind().on({
			submit:function(){
				// build data string
				var dataStr = filterListForm.serialize();
				dataStr = dataStr.replace(/\%5B/g, '[').replace(/\%5D/g, ']').replace(/\%255B/g, '[').replace(/\%255D/g, ']');
				var dataObj = $.getQueryParametersWithoutUrlQuery(dataStr);
				
				// modify filter attributes
				if (typeof dataObj.search_on === 'undefined'){
					delete dataObj['search_on'];
					delete dataObj['q'];
				}
				if (typeof dataObj.category_level_on === 'undefined'){
					delete dataObj['category_level_on'];
					delete dataObj['category_level'];
				}
				if (typeof dataObj.status_on === 'undefined'){
					delete dataObj['status_on'];
					delete dataObj['status'];
				}

				// finish data string
				dataStr = $.param(dataObj);
				dataStr = dataStr.replace(/\%5B/g, '[').replace(/\%5D/g, ']').replace(/\%255B/g, '[').replace(/\%255D/g, ']');

				// return
				if ($.trim(dataStr) == ''){
					var actionUrl = filterListForm.attr('action');
				} else {
					var actionUrl = filterListForm.attr('action')+(filterListForm.attr('action').indexOf('?') >= 0 ? '&' : '?')+dataStr;
				}
				if (typeof filterListForm.attr('data-ajax') !== 'undefined'){
					var container = $(filterListForm.attr('data-content-selector'));
					var submitButton = filterListForm.find('button[type="submit"]');
					submitButton.find('.icon').addClass('hidden');
					submitButton.addClass('button--disabled').append('<span class="loader"></div>');
					$.ajax({
						type:'GET',
						url:actionUrl,
						data:'',
						success:function(data){
							submitButton.removeClass('button--disabled');
							submitButton.find('.loader').remove();
							submitButton.find('.icon').removeClass('hidden');
							var dataObj = $('<div>'+data+'</div>');
							var dataObjContainer = dataObj.find(filterListForm.attr('data-content-selector'));
							container.html(dataObjContainer.html());
							app.reinit();
						}
					});
					return false;
				} else {
					window.location.href = actionUrl;
				}
				return false;
			}
		});

		// reset filter
		$('.button--reset-filter').unbind().on({
			click:function(){
				var resetButton = $(this);
				if (typeof resetButton.attr('data-ajax') !== 'undefined'){
					var container = $(resetButton.attr('data-content-selector'));
					resetButton.find('.icon').addClass('hidden');
					resetButton.addClass('button--disabled').append('<span class="loader"></div>');
					$.ajax({
						type:'GET',
						url:resetButton.attr('href'),
						data:'',
						success:function(data){
							resetButton.removeClass('button--disabled');
							resetButton.find('.loader').remove();
							resetButton.find('.icon').removeClass('hidden');
							var dataObj = $('<div>'+data+'</div>');
							var dataObjContainer = dataObj.find(resetButton.attr('data-content-selector'));
							container.html(dataObjContainer.html());
							app.reinit();
						}
					});
					return false;
				} else {
					window.location.href = resetButton.attr('href');
				}
			}
		});
	},
	initNav:function(){
		var that = this;

		that.nav.find('.dashboard__nav_inner > ul > li').each(function(){
			var navItem = $(this);
			if (typeof navItem.find('ul').html() !== 'undefined'){
				navItem.addClass('has-submenu').find('> a').append('<span class="icon icon--divider icon--arrow-down"></span>');
			}
		});

		that.nav.find('.dashboard__nav_inner > ul > li').unbind().on({
			click:function(e){
				var target = $(e.target);
				var navItem = $(this);
				var stickyElement = $('.dashboard__nav_container, .panel__nav_container');
				if (typeof stickyElement.data('stickySidebar') !== 'undefined'){
					stickyElement.data('stickySidebar').updateSticky();
				}
				if ((target.is('a') && target.attr('href') == '#') || target.is('span')){
					if (navItem.hasClass('active')){
						navItem.removeClass('active');
					} else {
						navItem.addClass('active');
					}
					return false;
				} else {
					//
				}
			}
		});
	},
	paymentError:function(form, data){
		var that = this;
		if (typeof $('.payment__loading').html() !== 'undefined'){
			$('.payment__loading .loader').remove();
			setTimeout(function(){
				window.location.href = window.location.origin;
			}, 8000);
		}
	},
	saveSettingsCallback:function(form, data){
		var that = this;
		if (data.section == 'email' && data.callbackStatus == 'verify_email'){
			$('#verify-email-message').removeClass('hidden');
		}
		app.modules.form.success(form, data, form.find('[name="responseTemplate"]').html() !== 'undefined' && form.find('[name="responseTemplate"]').val() == 'toaster' ? true : false);
	},
	openMobileNav:function(){
		var that = this;
		that.vars.canHideNav = false;
		that.vars.canChangeNaviScollState = false;
		that.body.addClass('open-nav');
		app.fixedContent(true);
	},
	closeMobileNav:function(){
		var that = this;
		that.body.removeClass('open-nav');
		app.fixedContent(false);
		setTimeout(function(){
			that.vars.canHideNav = true;
			that.vars.canChangeNaviScollState = true;
		}, 310);
	},
	reinit:function(){
		var that = this;
		that.init();
	}
};
app.modules.dashboard = new dashboard;
function lazyLoad(){
	this.$slider;
	this.vars = {
		slidesPerView:3,
		canUseWebP:app.canUseWebP()
	}
}
lazyLoad.prototype = {
	init:function(){
		var that = this;
		that.addListener();
		that.lazyLoadImages('[data-bg], img[data-src]');
	},
	addListener:function(){
		var that = this;
		$(window).on('scroll resize', function(){
			that.lazyLoadImages('[data-bg], img[data-src]');
		});
	},
	lazyLoadImages:function(selector){
		var that = this;
		setTimeout(function(){
			$(selector).each(function(i){
				var element = $(this);
				if (!element.hasClass('lazyload__loaded') || element.hasClass('lazyload__responsive')){
					if (($(window).height()+$(window).scrollTop())-element.offset().top > 0 && ($(window).width()+$(window).scrollLeft())-element.offset().left > 0 && $(window).scrollTop() < (element.offset().top+element.outerHeight()) && $(window).scrollLeft() < (element.offset().left+element.outerWidth())){
						if (typeof element.attr('data-bg') !== 'undefined'){
							var imageObj = element.attr('data-bg');
							var isJsonString = app.isJsonString(imageObj);
							if (isJsonString){
								element.addClass('lazyload__responsive');
								var imageObj = $.parseJSON(imageObj);
								if (Object.keys(imageObj).length){
									var screenSize = 'mobile';
									if (app.vars.screenDesktop){
										screenSize = 'desktop';
									} else if (app.vars.screenTablet){
										screenSize = 'tablet';
									}
									var imageSrc = typeof imageObj[screenSize] !== 'undefined' ? (imageObj[screenSize][that.vars.canUseWebP ? 'url_webp' : 'url']) : (imageObj[that.vars.canUseWebP ? 'url_webp' : 'url']);
								} else {
									imageSrc = '';
								}
							} else {
								var imageSrc = element.attr('data-bg');
							}
							that.loadImage(imageSrc, element, 'bg');
							element.css({
								'background-image':'url('+imageSrc+')'
							});
						}
						if (typeof element.attr('data-src') !== 'undefined'){
							var imageObj = element.attr('data-src');
							var isJsonString = app.isJsonString(imageObj);
							if (isJsonString){
								element.addClass('lazyload__responsive');
								var imageObj = $.parseJSON(imageObj);
								if (Object.keys(imageObj).length){
									var screenSize = 'mobile';
									if (app.vars.screenDesktop){
										screenSize = 'desktop';
									} else if (app.vars.screenTablet){
										screenSize = 'tablet';
									}
									var imageSrc = typeof imageObj[screenSize] !== 'undefined' ? (imageObj[screenSize][that.vars.canUseWebP ? 'url_webp' : 'url']) : (imageObj[that.vars.canUseWebP ? 'url_webp' : 'url']);
								} else {
									imageSrc = element.attr('src');
								}
							} else {
								var imageSrc = element.attr('data-src');
							}
							that.loadImage(imageSrc, element, 'src');
							element.attr('src', imageSrc);
						}
						if (typeof element.attr('data-lazyload-callback') !== 'undefined'){
							var callbackArr = element.attr('data-lazyload-callback').split('.');
							app.modules[callbackArr[0]][callbackArr[1]]();
						}
					}
				}
			});
		}, 10);
	},
	loadImage:function(url, element, type){
		if (url != ''){
			$('<img src="'+url+'">').on('load',function(){
				element.addClass('lazyload__loaded');
			});
		}
	},
	reset:function(selector){
		var that = this;
		$(selector).each(function(i){
			var element = $(this);
			if (element.hasClass('lazyload__loaded')){
				element.removeClass('lazyload__loaded');
				if (typeof element.attr('data-bg') !== 'undefined'){
					element.removeAttr('style');
				}
				if (typeof element.attr('data-src') !== 'undefined'){
					element.removeAttr('src');
				}
			}
		});
	},
	reinit:function(){
		var that = this;
		that.init();
	}
};
app.modules.lazyLoad = new lazyLoad;
function bootstrap(){}
bootstrap.prototype = {
	init:function(){
		var that = this;
		that.addListener();
	},
	addListener:function(){
		var that = this;

		// close dropdown on body click
		$('body').on('click', function(e){
			if (!$('.dropdown-toggle').is(e.target) && $('.dropdown-toggle').has(e.target).length === 0 && $('.open').has(e.target).length === 0 && typeof $(e.target).closest('.jcf-select-drop').html() === 'undefined'){
				$('.button__group, .dropdown-menu').removeClass('open');
				$('.dropdown-toggle').attr('aria-expanded', 'false');
			}
		});

		// toggle dropdoen menu
		$('.dropdown-toggle').unbind().on('click', function(e){
			var dropdownToggle = $(this);
			var dropdownMenu = dropdownToggle.next();
			var dropdownButtonGroup = dropdownToggle.closest('.button__group');
			setTimeout(function(){
				$('.dropdown-toggle').not(dropdownToggle).attr('aria-expanded', 'false');
				$('.dropdown-menu').not(dropdownMenu).removeClass('open');
				$('.button__group').not(dropdownButtonGroup).removeClass('open');
				if (dropdownMenu.hasClass('open')){
					dropdownMenu.removeClass('open');
					dropdownButtonGroup.removeClass('open');
					dropdownToggle.attr('aria-expanded', 'false');
				} else {
					dropdownMenu.addClass('open');
					dropdownButtonGroup.addClass('open');
					dropdownToggle.attr('aria-expanded', 'true');
				}
			}, 10);
		});

		$('.button__group').unbind().on('hide.bs.dropdown', function(e){
			var buttonGroup = $(this);
			if (buttonGroup.find('.jcf-select').hasClass('jcf-drop-active') || buttonGroup.find('.jcf-select').hasClass('jcf-focus')){
				return false;
			}
		});
	},
	reinit:function(){
		var that = this;
		that.addListener();
	}
};
app.modules.bootstrap = new bootstrap;
function _history(){
	this.vars = {
		allowStateChange:true
	}
}
_history.prototype = {
	init:function(){
		var that = this;
		that.addListener();

		var	History = window.History,
			$ = window.jQuery,
			document = window.document;

		if (!History.enabled){
			return false;
		}

		var	contentSelector = 'main',
			$content = $(contentSelector).filter(':first'),
			contentNode = $content.get(0),
			$menu = $('.ajax-menu:first').filter(':first'),
			activeClass = 'active',
			activeSelector = '.active',
			menuChildrenSelector = '> li, > ul > li',
			completedEventName = 'statechangecomplete',
			$window = $(window),
			$body = $(document.body),
			rootUrl = History.getRootUrl();

		if ($content.length === 0){
			$content = $body;
		}

		$.expr[':'].internal = function(obj, index, meta, stack){
			var	$this = $(obj),
				url = $this.attr('href') || '',
				isInternalLink;

			isInternalLink = url.substring(0, rootUrl.length) === rootUrl || url.indexOf(':') === -1;
			return isInternalLink;
		};

		$.fn.ajaxify = function(){
			var $this = $(this);
			$this.find('a.ajaxy:internal, .paging a').click(function(event){
				var	$this = $(this),
					url = $this.attr('href'),
					title = $this.attr('title') || null;

				if (event.which == 2 || event.metaKey){
					return true;
				}

				History.pushState(null, title, url);
				event.preventDefault();
				return false;
			});
			return $this;
		};

		$body.ajaxify();

		$window.bind('statechange',function(){
			if (!that.vars.allowStateChange){
				that.vars.allowStateChange = true;
				return false;
			}
			var	State = History.getState(),
				url = State.url,
				relativeUrl = url.replace(rootUrl, ''),
				stateMode = null;

			if (typeof State.data.mode !== 'undefined'){
				stateMode = State.data.mode;
			}
			if (stateMode == 'sleep'){
				// do nothing
			} else if (stateMode == 'onepager'){
				that.tracking(relativeUrl);
			} else {
				$body.addClass('loading');

				$content.animate({
					opacity:0
				}, 400, 'linear', function(){
					//
				});

				$.ajax({
					url:url,
					success:function(data, textStatus, jqXHR){
						var $data = $(that.documentHtml(data)),
							$dataBody = $data.find('.document-body:first'),
							$dataContent = $dataBody.find(contentSelector).filter(':first'),
							$menuChildren, contentHtml, $scripts;

						$scripts = $dataContent.find('.document-script');

						if ($scripts.length){
							$scripts.detach();
						}

						contentHtml = $dataContent.html() || $data.html();

						if (!contentHtml){
							document.location.href = url;
							return false;
						}

						$menuChildren = $menu.find(menuChildrenSelector);
						$menuChildren.filter(activeSelector).removeClass(activeClass);
						$menuChildren = $menuChildren.has('a[href^="'+relativeUrl+'"], a[href^="/'+relativeUrl+'"], a[href^="'+url+'"]');
						if ($menuChildren.length === 1){
							$menuChildren.addClass(activeClass);
						}

						$content.stop(true, true);
						$content.html(contentHtml).ajaxify().css('opacity', 100).show();

						$.each(app.modules, function(index, element){
							$.each(element, function(indexSub, elementSub){
								if (elementSub instanceof jQuery){
									app.modules[index][indexSub] = $(elementSub.selector);
								}
							});
						});
						app.reinit();

						that.updateTitle($data.find('.document-title:first').text());

						$scripts.each(function(){
							var $script = $(this), scriptText = $script.text(), scriptNode = document.createElement('script');
							if ($script.attr('src')){
								if (!$script[0].async){
									scriptNode.async = false;
								}
								scriptNode.src = $script.attr('src');
							}
							scriptNode.appendChild(document.createTextNode(scriptText));
							contentNode.appendChild(scriptNode);
						});

						$('body,html').animate({
							scrollTop:0
						}, 400, 'easeOutCubic', function(){
							//
						});
						$body.removeClass('loading');
						$window.trigger(completedEventName);

						that.tracking(relativeUrl);
					},
					error:function(jqXHR, textStatus, errorThrown){
						document.location.href = url;
						return false;
					}
				});
			}
		});
	},
	addListener:function(){
		var that = this;
	},
	documentHtml:function(html){
		var result = String(html).replace(/<\!DOCTYPE[^>]*>/i, '').replace(/<(html|head|body|title|meta|script)([\s\>])/gi,'<div class="document-$1"$2').replace(/<\/(html|head|body|title|meta|script)\>/gi,'</div>');
		return $.trim(result);
	},
	updateTitle:function(text){
		document.title = text;
		try { document.getElementsByTagName('title')[0].innerHTML = document.title.replace('<', '&lt;').replace('>', '&gt;').replace(' & ', ' &amp; '); }
		catch (Exception) { }
	},
	tracking:function(url){
		if (typeof gtag !== 'undefined' && typeof $('[data-gtag-tracking-id]').html() !== 'undefined'){
			var trackPath = url;
			var gtagTrackingScript = $('[data-gtag-tracking-id]');
			if (trackPath.charAt(0) == '/'){
				trackPath = trackPath.substring(1);
			}
			trackPath = '/'+trackPath;
			gtag('config', gtagTrackingScript.attr('data-gtag-tracking-id'), {
				'page_title':document.getElementsByTagName('title')[0].innerHTML,
				'page_path':trackPath,
				'anonymize_ip':gtagTrackingScript.attr('data-gtag-anonymize-ip') == 'true' ? true : false
			});
		}
	}
};
app.modules._history = new _history;
function overlay(){
	this.overlay = $('.overlay');
	this.overlayBody = $('.overlay__body');
	this.vars = {
		doing:false
	}
}
overlay.prototype = {
	init:function(){
		var that = this;
		that.addListener();

		// check overlay hash
		if (window.location.hash){
			var urlHash = window.location.hash;
			if (typeof $('.overlay[id="'+urlHash.replace('#', '')+'"]').html() !== 'undefined' && urlHash.replace('#', '') != 'confirm'){
				that.show('inline', urlHash.replace('#', ''));
			}
		}
	},
	addListener:function(){
		var that = this;

		// open overlay
		$('[data-overlay]:not([data-prevent-overlay])').unbind().on({
			click:function(){
				var overlayLink = $(this);
				if ($('.overlay').hasClass('overlay--show')){
					that.hide($('.overlay--show'));
					setTimeout(function(){
						that.prepare(overlayLink);
					}, 310);
				} else {
					that.prepare(overlayLink);
				}
				return false;
			}
		});

		// hide overlay
		$('.overlay .overlay__content > .close, [href="#close"]').unbind().on({
			click:function(){
				that.hide($(this).parents('.overlay'));
				return false;
			}
		});
		$(document).keyup(function(e){
			if (e.keyCode == 27) {
				if (that.overlay.hasClass('overlay--show')){
					that.hide(that.overlay);
				}
			}
		});

		// init tabs
		$('.overlay .tabs--tabbing').tabbing({
			enableNav:true,
			disableInactive:false
		});
	},
	prepare:function(overlayLink){
		var that = this;
		if (typeof $('.overlay[id="'+overlayLink.attr('href').replace('#', '')+'"]').html() !== 'undefined'){
			that.show('inline', overlayLink.attr('href').replace('#', ''), overlayLink);
		} else if (typeof $('.overlay[id="'+overlayLink.attr('data-overlay')+'"]').html() !== 'undefined'){
			that.show('inline', overlayLink.attr('data-overlay'), overlayLink);
		} else {
			that.show('inline', 'loading');
			var checkIfDoing = setInterval(function(){
				if (that.vars.doing === false){
					clearInterval(checkIfDoing);
					$.ajax({
						type:'GET',
						url:overlayLink.attr('href'),
						data:typeof overlayLink.attr('data-data') !== 'undefined' ? overlayLink.attr('data-data') : null,
						error:function(jqXHR, exception, thrownError){
							that.throwError(jqXHR, exception, thrownError);
						},
						success:function(data){
							$('body').append(data);
							app.reinit();
							if (typeof overlayLink.attr('data-callback') !== 'undefined'){
								var callbackFunction = overlayLink.attr('data-callback').split('.');
								app.modules[callbackFunction[0]][callbackFunction[1]](overlayLink, data);
							}
							if ($('.overlay').hasClass('overlay--show')){
								that.hide($('.overlay--show'));
								that.show('inline', overlayLink.attr('data-overlay'), overlayLink);
							} else {
								that.show('inline', overlayLink.attr('data-overlay'), overlayLink);
							}
						}
					});
				}
			}, 20);
		}
	},
	show:function(type, id, button, disableHashChange){
		var that = this;
		var allowHashChange = true;
		that.vars.doing = true;
		var overlay = $('.overlay[id="'+id+'"]');
		app.fixedContent(true);
		$('.open > .dropdown-toggle').trigger('click');
		if ((typeof button !== 'undefined' && button[0].hasAttribute('data-hide-url')) || id == 'loading' || (typeof disableHashChange !== 'undefined' && disableHashChange)){
			allowHashChange = false;
		}
		
		// show callback
		if (typeof button !== 'undefined' && typeof button.attr('data-callback-on-show') !== 'undefined'){
			var callbackClose = button.attr('data-callback-on-show').split('.');
			setTimeout(function(){
				app.modules[callbackClose[0]][callbackClose[1]](overlay, button);
			}, 310);
		}

		$('html,body').addClass('fixed--overlay');
		if (type == 'inline'){
			overlay.addClass('overlay--show');
			if (id != 'confirm'){
				if (allowHashChange){
					app.modules._history.vars.allowStateChange = false;
					window.location.hash = id;
				}
			} else {
				$('.overlay[id="'+id+'"] [data-confirm-default-text]').text($('.overlay[id="'+id+'"] [data-confirm-default-text]').attr('data-confirm-default-text'));
				if (typeof button.html() !== 'undefined' && button.attr('data-confirm') !== 'undefined'){
					$('.overlay[id="'+id+'"] [data-confirm-default-text]').text(button.attr('data-confirm-text'));
					$('.overlay[id="'+id+'"] .button--confirm').attr('href', button.attr('data-confirm')).attr('data-redirect', typeof button.attr('data-redirect') !== 'undefined' ? button.attr('data-redirect') : false);
				}
			}
		}

		setTimeout(function(){
			that.vars.doing = false;
			overlay.addClass('overlay--loaded');
		}, 310);

		that.addListener();
	},
	hide:function(overlay){
		var that = this;
		if (typeof overlay.html() !== 'undefined'){
			overlay.removeClass('overlay--show overlay--loaded');
			$('html,body').removeClass('fixed--overlay');
			app.fixedContent(false);
			if (overlay[0].hasAttribute('id') && window.location.hash == '#'+overlay.attr('id')){
				app.modules._history.vars.allowStateChange = false;
				History.pushState(null, null, window.location.href.split('#')[0]);
			}

			// close callback
			if (typeof overlay.attr('data-callback-on-close') !== 'undefined'){
				if (overlay.attr('data-callback-on-close') == 'remove'){
					setTimeout(function(){
						overlay.remove();
					}, 310);
				} else {
					var callbackClose = overlay.attr('data-callback-on-close').split('.');
					setTimeout(function(){
						app.modules[callbackClose[0]][callbackClose[1]](overlay);
					}, 310);
				}
			}
		}

		setTimeout(function(){
			that.vars.doing = false;
		}, 310);

		that.addListener();
	},
	hideIfOpen:function(){
		var that = this;
		if ($('.overlay.overlay--show').length > 0){
			that.hide($('.overlay--show'));
		}
	},
	throwError:function(jqXHR, exception, thrownError){
		var that = this;
		that.hideIfOpen();
		if (jqXHR.status == 401){
			setTimeout(function(){
				that.show('inline', 'not-authorized', undefined, true);
			}, 310);
		} else if (jqXHR.status == 419){
			setTimeout(function(){
				that.show('inline', 'session-expired', undefined, true);
			}, 310);
		} else {
			var error = typeof jqXHR.responseJSON.errors !== 'undefined' ? jqXHR.responseJSON.errors : {error:jqXHR.responseJSON.message};
			var messagesHtml = '<ul>';
			$.each(error, function(index, message){
				messagesHtml += '<li>'+message+'</li>';
			});
			messagesHtml += '</ul>';
			$.toaster({
				priority:'error',
				message:messagesHtml
			});
		}
	},
	reinit:function(){
		this.addListener();
	}
};
app.modules.overlay = new overlay;
function alert(){}
alert.prototype = {
	init:function(){
		var that = this;
		that.addListener();
	},
	addListener:function(){
		var that = this;

		// close alert box
		$('.alert .close').on({
			click:function(){
				var alertCloseBtn = $(this);
				var parentFormRow = alertCloseBtn.closest('.form__row');
				alertCloseBtn.closest('.alert').remove();
				parentFormRow.remove();
				return false;
			}
		});
	}
};
app.modules.alert = new alert;
function loading(){
	this.vars = {
		infinePadding:50,
		infiniteLoading:false,
		canClickLoad:true
	}
}
loading.prototype = {
	init:function(){
		var that = this;
		that.addListener();

		// infinite load check
		$(window).on('load resize scroll', function(e){
			that.infiniteLoadCheck($(this));
		});
	},
	addListener:function(){
		var that = this;

		// inline load infinite
		$('[data-load-infinite][data-load-infinite-mode="inline"]').parent().on({
			scroll:function(){
				var item = $(this);
				var itemLoad = item.find('[data-load-infinite]');
				if (item[0].scrollHeight - item.scrollTop() == item.height()){
					if (typeof itemLoad.attr('data-end') === 'undefined' && !that.vars.infiniteLoading){
						that.infiniteLoad(itemLoad);
					}
				}
			}
		});

		// click load infinite
		$('.loader_load_more').unbind().on({
			click:function(){
				if (that.vars.canClickLoad){
					that.vars.canClickLoad = false;
					var loaderButton = $(this);
					var item = loaderButton.prev();
					that.infiniteLoad(item);
				}
			}
		});
	},
	infiniteLoadCheck:function(window){
		var that = this;
		$('[data-load-infinite]:not([data-load-infinite-mode="inline"])').each(function(){
			var item = $(this);
			if (typeof item.attr('data-load-infinite-button') !== 'undefined'){
				if (typeof item.next('.loader_load_more').html() === 'undefined' && that.vars.canClickLoad){
					item.after('<div class="loader_load_more"><div>'+item.attr('data-load-infinite-button')+'</div></div>');
					that.addListener();
				}
			} else {
				var itemTopPos = item.offset().top;
				var itemHeight = item.outerHeight();
				var windowScrollTop = window.scrollTop();
				var windowHeight = app.getViewport('height');			
				if (itemTopPos+itemHeight-windowScrollTop+that.vars.infinePadding < windowHeight){
					if (typeof item.attr('data-end') === 'undefined' && !that.vars.infiniteLoading){
						that.infiniteLoad(item);
					}
				}
			}
		});
	},
	infiniteLoad:function(item){
		var that = this;
		that.infiniteShowLoader(item);
		$.ajax({
			type:'POST',
			url:item.attr('data-load-infinite'),
			data:'page='+(typeof item.attr('data-next-page') === 'undefined' ? 2 : item.attr('data-next-page'))+(typeof item.attr('data-data') !== 'undefined' ? '&'+item.attr('data-data') : ''),
			success:function(data){
				item.append(data.html);
				if (typeof item.attr('data-next-page') === 'undefined'){
					item.attr('data-next-page', 3);
				} else {
					item.attr('data-next-page', parseInt(item.attr('data-next-page'))+1);
				}
				if (!data.hasMorePages){
					item.attr('data-end', true);
				} else {
					if (typeof item.next().next('.loader_load_more').html() !== 'undefined'){
						item.next().next('.loader_load_more').removeClass('hidden');
					}
				}
				if (typeof item.attr('data-module') !== 'undefined'){
					app.modules[item.attr('data-module')].addListener();
				}
				if (typeof data.callbackJs !== 'undefined'){
					if ($.isArray(data.callbackJs[0])){
						$.each(data.callbackJs, function(key, value){
							if (typeof app.modules[value[0]] !== 'undefined'){
								app.modules[value[0]][value[1]](item, data);
							}
						});
					} else {
						app.modules[data.callbackJs[0]][data.callbackJs[1]](item, data);
					}
				}
				that.addListener();
				app.modules.form.addListener();
				app.modules.overlay.addListener();
				app.modules.tooltip.init();
				that.infiniteHideLoader(item);
				that.vars.canClickLoad = true;
			}
		});
	},
	infiniteShowLoader:function(item){
		var that = this;
		that.vars.infiniteLoading = true;
		item.after('<div class="loader_bar"><div class="loader loader--small"></div></div>');
		if (typeof item.next().next('.loader_load_more').html() !== 'undefined'){
			item.next().next('.loader_load_more').addClass('hidden');
		}
	},
	infiniteHideLoader:function(item){
		var that = this;
		that.vars.infiniteLoading = false;
		item.next('.loader_bar').remove();
	},
	startOverlay:function(form, data){
		var that = this;
		$.ajax({
			type:'POST',
			url:$('meta[name="site-url"]').attr('content')+'/events/loader/overlay',
			data:'loadingUrl='+data.loadingUrl,
			success:function(data){
				$('body').append(data.html);
				setTimeout(function(){
					that.processingOverlay(data);
				}, 300);
			}
		});
	},
	processingOverlay:function(data){
		var that = this;
		$.ajax({
			type:'POST',
			url:data.loadingUrl,
			data:'loadingUrl='+data.loadingUrl,
			success:function(data){
				$('.progress__bar_inner').width(data.progress+'%');
				if (data.end !== true){
					that.processingOverlay(data);
				} else if (data.redirect !== false){
					window.location.href = data.redirect;
				}
			}
		});
	},
	reinit:function(){
		var that = this;
		that.addListener();
	}
};
app.modules.loading = new loading;
function tooltip(){}
tooltip.prototype = {
	init:function(){
		var that = this;
		that.addListener();

		// init tooltip
		$('.tooltip').remove();
		$('[data-toggle="tooltip"]').tooltip({
			placement:'bottom',
			html:true,
			animation:true,
			boundary:'window'
		});
	},
	addListener:function(){
		var that = this;
	},
	reinit:function(){
		var that = this;
		that.init();
	}
};
app.modules.tooltip = new tooltip;
function anchor(){
	this.vars = {
		isScrolling:false
	}
}
anchor.prototype = {
	init:function(){
		var that = this;
		var paddingObject = $('header > .block, header > .topbar');
		that.addListener();

		if ($.trim(window.location.hash) != ''){
			$(window).on({
				load:function(){
					setTimeout(function(){
						var hash = $.trim(window.location.hash);
						var target = $('a[name="'+hash.replace('#', '')+'"]');
						if (typeof target.html() !== 'undefined'){
							var newScrollTopPos = target.offset().top;
							if (paddingObject && paddingObject.length > 0 && paddingObject.css('position') == 'fixed'){
								newScrollTopPos = newScrollTopPos-paddingObject.outerHeight();
							}
							$('html,body').scrollTop(newScrollTopPos);
							$('a[href$="'+hash+'"][data-anchor-link]:not([data-overlay]):not(a[href="#"])').parent().addClass('active');
						}
					}, 100);
				}
			});
		}
	},
	addListener:function(){
		var that = this;

		$('a[data-anchor-link]:not([data-overlay]):not(a[href="#"])').on({
			click:function(e){
				e.preventDefault();
				var link = $(this);
				var currentUrl = $('meta[name="current-url"]').attr('content');
				var target = $('a[name="'+link.attr('href').replace(currentUrl+'/', '').replace(currentUrl, '').replace('#', '')+'"]');
				if (typeof target.html() !== 'undefined'){
					that.vars.isScrolling = true;
					if (typeof $('body').attr('event-delay') !== 'undefined'){
						eventDelay = parseInt($('body').attr('event-delay'));
						setTimeout(function(){
							that.move(link, target);
						}, eventDelay);

					} else {
						that.move(link, target);
					}
				} else {
					window.location.href = link.attr('href');
				}
			}
		});
	},
	move:function(link, target){
		var that = this;
		var paddingObject = $('header > .block, header > .topbar');
		var newScrollTopPos = target.offset().top;
		var linkArr = link.attr('href').split('#');
		var hash = linkArr[linkArr.length-1];
		if (paddingObject && paddingObject.length > 0 && paddingObject.css('position') == 'fixed'){
			newScrollTopPos = newScrollTopPos-paddingObject.outerHeight();
		}
		$('a[data-anchor-link]:not([data-overlay]):not(a[href="#"])').parent().removeClass('active');
		link.parent().addClass('active');
		$('html,body').stop(true, true).animate({
			scrollTop:newScrollTopPos
		}, 800, 'easeInOutExpo', function(){
			that.vars.isScrolling = false;
			if (History.pushState){
				app.modules._history.vars.allowStateChange = false;
				History.pushState(null, null, '-');
				History.pushState(null, null, link.attr('href'));
			} else {
				app.modules._history.vars.allowStateChange = false;
			    window.location.hash = hash;
			}
		});
	}
};
app.modules.anchor = new anchor;
function fileuploader(){}
fileuploader.prototype = {
	init:function(){
		var that = this;
		that.addListener();

		// init fileuploader
		$('input[type="file"]').each(function(){
			var fileField = $(this);
			if (!fileField.hasClass('filer')){
				var fileOptions = {
		            limit:typeof fileField.attr('data-limit') !== 'undefined' ? fileField.attr('data-limit') : 30,
		            maxSize:typeof fileField.attr('data-maxSize') !== 'undefined' ? fileField.attr('data-maxSize') : 100,
		            fileMaxSize:typeof fileField.attr('data-fileMaxSize') !== 'undefined' ? fileField.attr('data-fileMaxSize') : 20,
		            extensions:typeof fileField.attr('data-extensions') !== 'undefined' ? fileField.attr('data-extensions') : ['jpg', 'jpeg', 'png', 'gif', 'pdf', 'doc', 'docx', 'ppt', 'xls', 'xlsx', 'csv', 'zip', 'mp4'],
		            disallowedExtensions:typeof fileField.attr('data-disallowedExtensions') !== 'undefined' ? fileField.attr('data-disallowedExtensions') : ['exe'],
		            theme:typeof fileField.attr('data-theme') !== 'undefined' ? fileField.attr('data-theme') : 'default',
		            enableApi:true,
		            changeInput:typeof fileField.attr('data-theme') !== 'undefined' && fileField.attr('data-theme') == 'dragdrop' ? '<div class="fileuploader-input">'+
					      '<div class="fileuploader-input-inner">'+
						      '<div class="fileuploader-main-icon"></div>'+
							  '<h3 class="fileuploader-input-caption"><span>${captions.feedback}</span></h3>'+
							  '<p>${captions.or}</p>' +
						  '</div>' +
					  '</div>' : (typeof fileField.attr('data-theme') !== 'undefined' && fileField.attr('data-theme') == 'onebutton' ? (typeof fileField.attr('data-title') !== 'undefined' ? '<div class="button button--white button--bordercolor-primary button--color-primary" data-default-text="${captions.button}"><span class="icon icon--inline-left icon--media"></span><span class="txt">'+fileField.attr('data-title')+'</span><span class="close close--small"></span></div>' : '<div class="button button--white"><span class="icon icon--inline-left icon--arrow-top2"></span><span class="txt">${captions.button}</span></div>') : true),
		            thumbnails:{
		            	box:'	<div class="fileuploader-items">'+
		            				'<ul class="fileuploader-items-list"></ul>'+
		            			'</div>',
		            	boxAppendTo:null,
		            	item:'	<li class="fileuploader-item">'+
			            			'<div class="columns">'+
			            				'<div class="column-thumbnail">${image}</div>'+
		            					'<div class="column-title">'+
		            						'<div title="${name}">${name}</div>'+
		            						'<span>${size2}</span>'+
		            					'</div>'+
		            					'<div class="column-actions">'+
		            						'<a class="fileuploader-action fileuploader-action-remove" title="${captions.remove}"><i></i></a>'+
		            					'</div>'+
		            				'</div>'+
			            			'<div class="progress-bar2">${progressBar}<span></span></div>'+
		            		  	'</li>',
		            	item2:  '<li class="fileuploader-item">'+
		            				'<div class="columns">'+
		            					'<div class="column-thumbnail">${image}</div>'+
					                    '<div class="column-title">'+
					                    	'<a href="${file}" target="_blank">'+
					                    		'<div title="${name}">${name}</div>'+
					                    		'<span>${size2}</span>'+
					                    	'</a>'+
					                    '</div>'+
					                    '<div class="column-actions">'+
					                    	'<a href="${file}" class="fileuploader-action fileuploader-action-download" title="${captions.download}" download><i></i></a>'+
					                    	'<a class="fileuploader-action fileuploader-action-remove" title="${captions.remove}"><i></i></a>'+
					                    '</div>'+
					                '</div>'+
					            '</li>',
					    _selectors:{
					    	list:'.fileuploader-items-list',
					    	item:'.fileuploader-item',
					    	start:'.fileuploader-action-start',
					    	retry:'.fileuploader-action-retry',
					    	remove:'.fileuploader-action-remove',
					    	sorter:'.fileuploader-action-sort',
					    	rotate:'.fileuploader-action-rotate',
					    	popup:'.fileuploader-popup-preview',
					    	popup_open:'.fileuploader-action-popup'
					    },
					    itemPrepend:false,
					    removeConfirmation:true,
					    startImageRenderer:true,
					    synchronImages:true,
					    useObjectUrl:false,
					    canvasImage:true,
					    videoThumbnail:false,
					    exif:true,
					    beforeShow:null,
					    onItemShow:null,
					    onItemRemove:function(html){
					    	html.children().animate({'opacity':0}, 200, function(){
					    		setTimeout(function(){
					    			html.slideUp(200, function(){
					    				html.remove();
					    			});
					    		}, 100);
					    	});
					    },
					    onImageLoaded:function(item, listEl, parentEl, newInputEl, inputEl){
					    	if (item.image.hasClass('fileuploader-no-thumbnail')){
					    		//
					    	}
					    	if (item.reader.node && item.reader.width > 1920 && item.reader.height > 1080 && item.reader.ratio != '16:9'){
					    		//
					    	}
					    }
					},
					dragDrop:{
						container:null,
						onDragEnter:function(event, listEl, parentEl, newInputEl, inputEl){
							//
						},
						onDragLeave:function(event, listEl, parentEl, newInputEl, inputEl){
							//
						},
						onDrop:function(event, listEl, parentEl, newInputEl, inputEl){
							//
						}
					},
					editor:null,
					sorter:{
						selectorExclude:null,
						placeholder:null,
						scrollContainer:window,
						onSort:function(list, listEl, parentEl, newInputEl, inputEl){
							//
						}
					},
					onSupportError:function(parentEl, inputEl){
						//
					},
					beforeRender:function(parentEl, inputEl){
						inputEl.addClass('filer');
						return true;
					},
					afterRender:function(listEl, parentEl, newInputEl, inputEl){
						app.modules.form.addListener();
					},
					beforeSelect:function(files, listEl, parentEl, newInputEl, inputEl){
						return true;
					},
					onFilesCheck:function(files, options, listEl, parentEl, newInputEl, inputEl){
						return true;
					},
					onFileRead:function(item, listEl, parentEl, newInputEl, inputEl){
						//
					},
					onSelect:function(item, listEl, parentEl, newInputEl, inputEl){
						//
					},
					afterSelect:function(listEl, parentEl, newInputEl, inputEl){
						//
					},
					onListInput:function(list, fileList, listInputEl, listEl, parentEl, newInputEl, inputEl){
						return list;
					},
					onRemove:function(item, listEl, parentEl, newInputEl, inputEl){
						return true;
					},
					onEmpty:function(listEl, parentEl, newInputEl, inputEl){
						//
					},
					captions:{
						button:function(options){
							if (options.limit == 1){
								return (typeof window['translations']['browse_file'] !== 'undefined' ? window['translations']['browse_file'] : 'Browse file');
							} else {
								return (typeof window['translations']['browse_files'] !== 'undefined' ? window['translations']['browse_files'] : 'Browse files');
							}
						},
						feedback:function(options){
							if (options.limit == 1){
								return (typeof window['translations']['choose_file_to_upload'] !== 'undefined' ? window['translations']['choose_file_to_upload'] : 'Choose file to upload');
							} else {
								return (typeof window['translations']['choose_files_to_upload'] !== 'undefined' ? window['translations']['choose_files_to_upload'] : 'Choose files to upload');
							}
						},
						feedback2:function(options){
							if (options.length > 1){
								return options.length+' '+(typeof window['translations']['file_was_chosen'] !== 'undefined' ? window['translations']['file_was_chosen'] : 'file was chosen');
							} else {
								return options.length+' '+(typeof window['translations']['files_were_chosen'] !== 'undefined' ? window['translations']['files_were_chosen'] : 'files were chosen');
							}
						},
						confirm:(typeof window['translations']['confirm'] !== 'undefined' ? window['translations']['confirm'] : 'Confirm'),
						cancel:(typeof window['translations']['cancel'] !== 'undefined' ? window['translations']['cancel'] : 'Cancel'),
						name:(typeof window['translations']['name'] !== 'undefined' ? window['translations']['name'] : 'Name'),
						type:(typeof window['translations']['type'] !== 'undefined' ? window['translations']['type'] : 'Type'),
						size:(typeof window['translations']['size'] !== 'undefined' ? window['translations']['size'] : 'Size'),
						dimensions:(typeof window['translations']['dimensions'] !== 'undefined' ? window['translations']['dimensions'] : 'Dimensions'),
						duration:(typeof window['translations']['duration'] !== 'undefined' ? window['translations']['duration'] : 'Duration'),
						crop:(typeof window['translations']['crop'] !== 'undefined' ? window['translations']['crop'] : 'Crop'),
						rotate:(typeof window['translations']['rotate'] !== 'undefined' ? window['translations']['rotate'] : 'Rotate'),
						sort:(typeof window['translations']['sort'] !== 'undefined' ? window['translations']['sort'] : 'Sort'),
						download:(typeof window['translations']['download'] !== 'undefined' ? window['translations']['download'] : 'Download'),
						remove:(typeof window['translations']['remove'] !== 'undefined' ? window['translations']['remove'] : 'Remove'),
						drop:(typeof window['translations']['drop_files_to_upload'] !== 'undefined' ? window['translations']['drop_files_to_upload'] : 'Drop the files here to Upload'),
						paste:'<div class="fileuploader-pending-loader"></div> '+(typeof window['translations']['pasting_a_file_click_to_cancel'] !== 'undefined' ? window['translations']['pasting_a_file_click_to_cancel'] : 'Pasting a file, click here to cancel.'),
						removeConfirmation:(typeof window['translations']['are_you_sure_to_remove'] !== 'undefined' ? window['translations']['are_you_sure_to_remove'] : 'Are you sure you want to remove this file?'),
						errors:{
							filesLimit:(typeof window['translations']['files_limit_exceed'] !== 'undefined' ? window['translations']['files_limit_exceed'] : 'Only ${limit} files are allowed to be uploaded.'),
							filesType:(typeof window['translations']['invalid_file_extensions'] !== 'undefined' ? window['translations']['invalid_file_extensions'] : 'Only ${extensions} files are allowed to be uploaded.'),
							fileSize:(typeof window['translations']['file_size_exceed'] !== 'undefined' ? window['translations']['file_size_exceed'] : '${name} is too large! Please choose a file up to ${fileMaxSize}MB.'),
							filesSizeAll:(typeof window['translations']['files_size_exceed'] !== 'undefined' ? window['translations']['files_size_exceed'] : 'Files that you chose are too large! Please upload files up to ${maxSize} MB.'),
							fileName:(typeof window['translations']['file_already_exists'] !== 'undefined' ? window['translations']['file_already_exists'] : 'File with the name ${name} is already selected.'),
							folderUpload:(typeof window['translations']['folders_not_allowed'] !== 'undefined' ? window['translations']['folders_not_allowed'] : 'You are not allowed to upload folders.')
						}
					}
		        };
		        if (typeof fileField.attr('data-upload') !== 'undefined'){
		        	fileOptions.upload = {
		        		url:fileField.attr('data-uploadUrl'),
		        		data:typeof fileField.attr('data-uploadData') !== 'undefined' ? fileField.attr('data-uploadData') : null,
		        		type:'POST',
		        		enctype:'multipart/form-data',
		        		start:true,
		        		synchron:true,
		        		chunk:false,
		        		beforeSend:function(item, listEl, parentEl, newInputEl, inputEl){
		        			item.upload.data.gallery_item = typeof fileField.attr('data-gallery-item') !== 'undefined' ? true : false;
		        			item.upload.data.custom_data = typeof fileField.attr('data-custom-data') !== 'undefined' ? fileField.attr('data-custom-data') : false;
		        			if (typeof inputEl.attr('data-theme') !== 'undefined' && inputEl.attr('data-theme') == 'onebutton'){
		        				inputEl.attr('disabled', 'disabled');
		        				inputEl.next().attr('data-default-text', inputEl.next().text());
		        				inputEl.next().removeClass('button--bordercolor-error button--color-error button--bordercolor-primary button--color-primary').addClass('button--disabled').html('<span class="icon icon--inline-left icon--media"></span>'+(item.title.length <= 27 ? item.title : (item.title.slice(0, 27)+' ...'))+'<span class="loader"></span>');
		        			}
		        			return true;
		        		},
		        		onSuccess:function(data, item, listEl, parentEl, newInputEl, inputEl, textStatus, jqXHR){
		        			if (typeof inputEl.attr('data-theme') !== 'undefined' && inputEl.attr('data-theme') == 'onebutton'){
		        				inputEl.next().addClass('button--bordercolor-primary button--color-primary').html('<span class="icon icon--inline-left icon--media"></span>'+(item.title.length <= 27 ? item.title : (item.title.slice(0, 27)+' ...'))+'<span class="close close--small"></span>');
		        			}
		        			item.remove();
		        			$('.panel__body.hidden, .panel__footer.hidden').removeClass('hidden');
		        			$('#media-tiles').prepend(data.html);
		        			app.reinit();
		        			app.modules.lazyLoad.lazyLoadImages('#media-tiles [data-bg], #media-tiles img[data-src]');
		        		},
		        		onError:function(item, listEl, parentEl, newInputEl, inputEl, jqXHR, textStatus, errorThrown){
		        			if (typeof inputEl.attr('data-theme') !== 'undefined' && inputEl.attr('data-theme') == 'onebutton'){
		        				inputEl.next().addClass('button--bordercolor-error button--color-error').html('<span class="icon icon--inline-left icon--media"></span>'+(item.title.length <= 27 ? item.title : (item.title.slice(0, 27)+' ...'))+'<span class="close close--small"></span>');
		        			}
		        			var progressBar = item.html.find('.progress-bar2');
		        			if (progressBar.length > 0){
		        				progressBar.find('span').html(0+'%');
		        				progressBar.find('.fileuploader-progressbar .bar').width(0+'%');
		        				item.html.find('.progress-bar2').fadeOut(400);
		        			}
		        			item.upload.status != 'cancelled' && item.html.find('.fileuploader-action-retry').length == 0 ? item.html.find('.column-actions').prepend(
		        				'<a class="fileuploader-action fileuploader-action-retry" title="Retry"><i></i></a>'
		        			) : null;
		        			var messagesHtml = '<ul>';
							$.each(jqXHR.responseJSON, function(index, message){
								messagesHtml += '<li>'+message+'</li>';
							});
							messagesHtml += '</ul>';
							$.toaster({
								priority:'error',
								message:messagesHtml
							});
							app.reinit();
		        		},
		        		onProgress:function(data, item, listEl, parentEl, newInputEl, inputEl){
		        			var progressBar = item.html.find('.progress-bar2');
		        			if (progressBar.length > 0){
		        				progressBar.show();
		        				progressBar.find('span').html(data.percentage+'%');
		        				progressBar.find('.fileuploader-progressbar .bar').width(data.percentage+'%');
		        			}
		        		},
		        		onComplete:function(listEl, parentEl, newInputEl, inputEl, jqXHR, textStatus){
		        			if (typeof inputEl.attr('data-theme') !== 'undefined' && inputEl.attr('data-theme') == 'onebutton'){
		        				inputEl.removeAttr('disabled');
		        				inputEl.next().removeClass('button--disabled');
		        				if (typeof jqXHR.responseJSON !== 'undefined'){
		        					inputEl.closest('.fileuploader').next().val(jqXHR.responseJSON.id);
		        				} else {
		        					inputEl.closest('.fileuploader').next().val(jqXHR.responseText);
		        				}
		        				if (jQuery().dirtyForms){
			        				$('.form--dirty').dirtyForms('rescan');
								}
		        			}
		        		}
		        	};
		        }
		        if (typeof fileField.attr('value') !== 'undefined' && fileField.attr('value') != ''){
		        	fileOptions.files = jQuery.parseJSON(fileField.attr('value'));
		        }
		        fileField.fileuploader(fileOptions);
		    }
		});
	},
	addListener:function(){
		var that = this;
	},
	fileAdded:function(){
		var that = this;
	},
	reinit:function(){
		var that = this;
		that.init();
	}
};
app.modules.fileuploader = new fileuploader;
function toaster(){}
toaster.prototype = {
	init:function(){
		var that = this;
		that.addListener();

		// init toaster
		$.toaster({
			settings:{
				timeout:8000,
				toaster:{
					css:{
						width:'300px'
					}
				},
				toast:{
					template:'<div class="alert alert--%priority% alert--dismissible" role="alert"><div class="close close--toaster close--small" data-dismiss="alert"></div><p class="message"></p></div>',
					display:function($toast){
						return $toast.fadeIn(0);
					},
					remove:function($toast, callback){
						return $toast.animate({
							opacity:0
						}, {
							duration:0,
							complete:callback
						});
					}
				}
			}
		});
	},
	addListener:function(){
		var that = this;
	}
};
app.modules.toaster = new toaster;
function cms(){
	this.emptyMessage = $('.panel__blocks_empty');
	this.vars = {
		fieldSettingsQueryObj:{
			value:{
				background:null,
				border:{
					top:0,
					bottom:0
				},
				hide:0
			},
			page:null,
			module:null
		},
		currentSwiperIndexes:null
	}
}
cms.prototype = {
	init:function(){
		var that = this;
		that.addListener();
	},
	addListener:function(){
		var that = this;

		// open/close block
		$('.panel__block .expand').unbind().on({
			click:function(){
				var expander = $(this);				
				var stickyElement = $('.dashboard__nav_container, .panel__nav_container');
				if (typeof stickyElement.data('stickySidebar') !== 'undefined'){
					stickyElement.data('stickySidebar').updateSticky();
				}
				var block = expander.closest('.panel__block');
				block.toggleClass('open');
				app.modules.lazyLoad.lazyLoadImages('[data-bg], img[data-src]');
				setTimeout(function(){
					app.modules.hint.parseHints('[data-hint="hide-fields"]');
					app.modules.ace.resizeEditor();
				}, 100);
				return false;
			}
		});

		// show/hide field
		$('.form__visibility').unbind().on({
			click:function(){
				var visibilityButton = $(this);
				var formFieldWrapper = visibilityButton.closest('.form__field_wrapper');
				var fieldName = visibilityButton.attr('data-field-name');
				var fieldNameArr = fieldName.split('[value]');
				var shortFieldName = fieldNameArr[fieldNameArr.length-1];
				var newFieldName = fieldNameArr.slice(0, fieldNameArr.length-1).join('[value]');
				newFieldName = newFieldName+'[hidden][';
				newFieldName = newFieldName+(shortFieldName.replace(/\[/g, '').replace(/\]/g, ''))+']';
				if (formFieldWrapper.hasClass('form__field_wrapper--hidden')){
					formFieldWrapper.removeClass('form__field_wrapper--hidden');
					visibilityButton.find('input[name="'+newFieldName+'"]').remove();
				} else {
					formFieldWrapper.addClass('form__field_wrapper--hidden');
					visibilityButton.append('<input type="hidden" name="'+newFieldName+'" value="1" />');
				}
				return false;
			}
		});

		// remove block
		$('.panel__block .block__heading .remove').unbind().on({
			click:function(){
				var block = $(this).closest('.panel__block');
				var blockParent = block.parents('.panel__block');
				var blockContaianer = block.parent();
				if (blockContaianer.children().length == 1){
					blockContaianer.removeClass('form__list_container--filled');
					if (typeof blockParent.html() === 'undefined'){
						blockContaianer.parent().find('.panel__blocks_empty').removeClass('hidden');
					}
				}
				block.remove();
			}
		});
	},
	openedModuleOverlay:function(overlay, button){
		var that = this;
		app.modules.lazyLoad.lazyLoadImages('img[data-src]');

		// sticky sidebar
		setTimeout(function(){
			$('._04__sidebar ul').stickySidebar({
				minWidth:1024,
				topSpacing:30,
				bottomSpacing:30,
				containerSelector:'._04',
				innerWrapperSelector:'._04__sidebar'
			});
		}, 310);
	},
	switchTheme:function(button, data){
		var that = this;
		$('#theme-body').html(data.html);
		$('._04__sidebar a').removeClass('active');
		var stickyElement = $('._04__sidebar ul');
		if (typeof stickyElement.data('stickySidebar') !== 'undefined'){
			stickyElement.data('stickySidebar').updateSticky();
		}
		button.addClass('active');
		app.reinit();
		app.modules.lazyLoad.lazyLoadImages('img[data-src]');
	},
	switchThemeModules:function(button, data){
		var that = this;
		var stickyElement = $('._04__sidebar ul');
		if (typeof stickyElement.data('stickySidebar') !== 'undefined'){
			stickyElement.data('stickySidebar').updateSticky();
		}
		$('#modules-body').html(data.html);
		$('._04__sidebar a').removeClass('active');
		$('._04__sidebar a[data-theme-id="'+data.theme+'"]').addClass('active');
		app.reinit();
		app.modules.lazyLoad.lazyLoadImages('img[data-src]');
	},
	addModule:function(button, data){
		var that = this;
		that.emptyMessage.addClass('hidden');
		$('#page-content').append(data.htmlBackend);
		app.modules.overlay.hideIfOpen();
		app.reinit();
	},
	addModuleItem:function(button, data){
		var that = this;
		$('.form__list_container[data-list="'+data.listName+'"]').addClass('form__list_container--filled').append(data.htmlBackend);
		app.reinit();
	},
	applyFieldSettings:function(form, data){
		var that = this;
		var frame = $('#editor');
		var frameContent = frame.contents();
		var section = frameContent.find('section[data-module-key="'+data.moduleKey+'"]');
		var block = section.find('.block');
		app.modules.overlay.hideIfOpen();
		if (data.field == 'block'){			
			// background
			var valBackground = data.data.value[data.moduleKey].value.background;
			$('.editor', parent.document).find('[name="modules['+data.moduleKey+'][value][background]"]').val(valBackground);
			block.removeClass(function(index, className){
				return (className.match(/(^|\s)block--bg-\S+/g) || []).join(' ');
			}).addClass('block--bg-'+valBackground);
			that.vars.fieldSettingsQueryObj.value.background = valBackground;

			// border
			var valBorder = data.data.value[data.moduleKey].value.border;
			block.removeClass('block--border-top block--border-bottom');
			if (typeof valBorder !== 'undefined'){
				if (typeof valBorder.top !== 'undefined' && valBorder.top){
					$('.editor', parent.document).find('[name="modules['+data.moduleKey+'][value][border][top]"]').prop('checked', true);
					block.addClass('block--border-top');
					that.vars.fieldSettingsQueryObj.value.border.top = valBorder.top;
				} else {
					$('.editor', parent.document).find('[name="modules['+data.moduleKey+'][value][border][top]"]').prop('checked', false);
					that.vars.fieldSettingsQueryObj.value.border.top = 0;
				}
				if (typeof valBorder.bottom !== 'undefined' && valBorder.bottom){
					$('.editor', parent.document).find('[name="modules['+data.moduleKey+'][value][border][bottom]"]').prop('checked', true);
					block.addClass('block--border-bottom');
					that.vars.fieldSettingsQueryObj.value.border.bottom = valBorder.bottom;
				} else {
					$('.editor', parent.document).find('[name="modules['+data.moduleKey+'][value][border][bottom]"]').prop('checked', false);
					that.vars.fieldSettingsQueryObj.value.border.bottom = 0;
				}
			} else {
				$('.editor', parent.document).find('[name="modules['+data.moduleKey+'][value][border][top]"]').prop('checked', false);
				that.vars.fieldSettingsQueryObj.value.border.top = 0;
				$('.editor', parent.document).find('[name="modules['+data.moduleKey+'][value][border][bottom]"]').prop('checked', false);
				that.vars.fieldSettingsQueryObj.value.border.bottom = 0;
			}

			// hide hide
			var valHide = data.data.value[data.moduleKey].value.hide;
			block.removeClass('block--hide');
			if (typeof valHide !== 'undefined'){
				$('.editor', parent.document).find('[name="modules['+data.moduleKey+'][value][hide]"]').prop('checked', true);
				block.addClass('block--hide');
				that.vars.fieldSettingsQueryObj.value.hide = 1;
			} else {
				$('.editor', parent.document).find('[name="modules['+data.moduleKey+'][value][hide]"]').prop('checked', false);
				that.vars.fieldSettingsQueryObj.value.hide = 0;
			}

			// settings
			var settingsData = data;
			delete settingsData.data.value[data.moduleKey].value.background;
			delete settingsData.data.value[data.moduleKey].value.border;
			delete settingsData.data.value[data.moduleKey].value.hide;
			var settingsValue = settingsData.data.value[data.moduleKey].value;
			var settingsValueLength = Object.keys(settingsValue).length;
			$.each(settingsData.data.value[data.moduleKey].value, function(settingsKey, settingsValue){
				var fieldName = 'modules['+data.moduleKey+'][value]['+settingsKey+']';
				if (typeof settingsValue === 'object' && settingsValue !== null && Object.keys(settingsValue)[0] == 0){
					var sidebarFieldsBody = $('.editor', parent.document).find('.sidebar__fields [name^="'+fieldName+'"]').closest('.form__row');
					var arrCounter = 0;
					sidebarFieldsBody.empty();
					$.each(settingsValue, function(objKey, objValue){
						if (typeof objValue === 'object'){
							$.each(objValue, function(objKeySub, objValueSub){
								sidebarFieldsBody.append('<input type="hidden" name="'+fieldName+'['+arrCounter+']['+objKeySub+']" value="'+objValueSub+'" />');
							});
							arrCounter++;
						} else {
							sidebarFieldsBody.append('<input type="hidden" name="'+fieldName+'['+arrCounter+']" value="'+objValue+'" />');
							arrCounter++;
						}
					});
				} else {
					$('.editor', parent.document).find('[name="'+fieldName+'"]').val(settingsValue);
				}
			});
			if (settingsValueLength > 0){
				that.resetModule(section, data);
			} else {
				that.updateModuleSettingsLink(section);
			}
		}
		if (data.field == 'link'){
			var linkButton = $('#'+data.id+'_button');
			var linkText = $('#'+data.id+'_text');
			var linkTarget = $('#'+data.id+'_target');
			var linkLink = $('#'+data.id+'_link');
			var linkModel = $('#'+data.id+'_model');
			var linkId = $('#'+data.id+'_id');
			var linkClass = $('#'+data.id+'_class');
			var linkExtension = $('#'+data.id+'_extension');
			var editorField = frameContent.find('.edit_field--link[data-field="'+(data.name)+'"]');
			linkButton.attr('href', data.url+'?'+app.getQueryString(data.data));
			linkButton.html(data.button)
			linkText.val(data.data.text);
			linkTarget.val(data.data.target);
			linkLink.val(data.data.link);
			linkModel.val(data.data.model);
			linkId.val(data.data.id);
			linkClass.val(data.data.class);
			linkExtension.val(data.data.extension);
			editorField.find('a').attr('class', ((typeof editorField.find('a').attr('data-class') !== 'undefined' ? editorField.find('a').attr('data-class')+(data.data.class != '' ? ' ' : '') : '')+data.data.class));
			if (typeof editorField.find('a').attr('data-text') === 'undefined'){
				if (typeof editorField.find('a [data-text]').html() !== 'undefined'){
					editorField.find('a [data-text]').text(data.data.text);
				} else {
					editorField.find('a').text(data.data.text);
				}
			}
		}
		if (data.field == 'media' || data.field == 'gallery'){
			if (data.id == 'logo'){
				if (data.data.media){
					var logoUrl = data.data.media.url_original;
					var logoOrigin = frameContent.find('[data-logo-origin]');
					var logoFooter = frameContent.find('[data-logo-footer]');
					if (typeof logoOrigin.find('img').html() !== 'undefined'){
						logoOrigin.find('img').attr('src', logoUrl);
					} else {
						logoOrigin.html('<img src="'+logoUrl+'" />');
					}
					if (data.data.updateFooter){
						if (typeof logoFooter.find('img').html() !== 'undefined'){
							logoFooter.find('img').attr('src', logoUrl);
						} else {
							logoFooter.html('<img src="'+logoUrl+'" />');
						}
					}
				}
			} else if (data.id == 'logo_footer'){
				if (data.data.media){
					var logoUrl = data.data.media.url_original;
					var logoOrigin = frameContent.find('[data-logo-origin]');
					var logoFooter = frameContent.find('[data-logo-footer]');
					if (typeof logoFooter.find('img').html() !== 'undefined'){
						logoFooter.find('img').attr('src', logoUrl);
					} else {
						logoFooter.html('<img src="'+logoUrl+'" />');
					}
					if (data.data.updateOrigin){
						if (typeof logoOrigin.find('img').html() !== 'undefined'){
							logoOrigin.find('img').attr('src', logoUrl);
						} else {
							logoOrigin.html('<img src="'+logoUrl+'" />');
						}
					}
				}
			} else {
				var inputField = $('#'+data.id);
				var inputFieldForm = inputField.closest('form');
				var fieldHtml = inputField.prev();
				if (data.data.media === null){
					var newImageVal = '';
				} else {
					var mediaReturnType = $.type(data.data.media);
					if (mediaReturnType == 'array'){
						var mediaId = '';
						$.each(data.data.media, function(key, value){
							if (key > 0){
								mediaId = mediaId+',';
							}
							mediaId = mediaId+value.id;
						});
					} else {
						var mediaId = data.data.media.id;
					}
					var newImageVal = data.field+'_'+mediaId;
				}
				var editorField = frameContent.find('.edit_field--image[data-field="'+(data.name)+'"]');
				var imageObj = editorField.find('img');
				var bgObj = editorField.find('[data-bg]');
				var videoObj = editorField.find('video');
				inputField.val(newImageVal);
				$('.editor', parent.document).find('[name="'+(data.name)+'"]').val(newImageVal);
				fieldHtml.remove();
				$(data.data.mediaHtml).insertBefore(inputField);
				if (imageObj.length > 0){
					var mediaSrcArr = imageObj.attr('src').split('/');
					var imageSize = mediaSrcArr[mediaSrcArr.length- 2];
					var newImageUrl = data.data.media.url_size_placeholder.replace('{size}', imageSize);
					if (data.data.mediaType == 'image'){
						imageObj.attr('src', newImageUrl).removeAttr('data-src');
					} else {
						imageObj.after('<video controls data-size="'+imageSize+'"><source src="'+data.data.media.url+'" type="video/mp4" /></video>');
						imageObj.remove();
					}
					editorField.attr('href', data.data.actionUrl);
				} else if (bgObj.length > 0){
					var mediaBgArr = bgObj.css('background-image').replace('url(','').replace(')','').replace(/\"/gi, "").split('/');
					var imageSize = mediaBgArr[mediaBgArr.length- 2];
					var newImageUrl = data.data.media.url_size_placeholder.replace('{size}', imageSize);
					bgObj.css('background-image', 'url('+newImageUrl+')').attr('data-bg', newImageUrl);
					editorField.attr('href', data.data.actionUrl);
				} else if (videoObj.length > 0){
					if (data.data.mediaType == 'image'){
						videoObj.after('<img src="'+data.data.media.sizes[videoObj.attr('data-size')].url+'" alt="" />');
						videoObj.remove();
					} else {
						videoObj.find('source').attr('src', data.data.media.url);
					}
					editorField.attr('href', data.data.actionUrl);
				}
				if (inputFieldForm.hasClass('form--dirty') && jQuery().dirtyForms){
					inputFieldForm.dirtyForms('rescan');
				}
			}
		}
		if (data.field == 'select'){
			var selectField = $('select[name="'+data.name+'"]');
			selectField.val(data.data.select);
		}

		// reload / reset
		if (data.forceReload && data.field != 'block'){
			that.resetModule(section, data);
		} else {
			app.reinit();
			if (frame.length){
				frame[0].contentWindow.app.reinit();
			}
		}
	},
	resetModule:function(section, data){
		var that = this;
		var frame = $('#editor');
		var newSection = null;
		var settingsButton = section.find('.edit_block__button--settings');
		that.vars.fieldSettingsQueryObj.page = settingsButton.attr('data-page');
		that.vars.fieldSettingsQueryObj.module = settingsButton.attr('data-module');		
		that.vars.currentSwiperIndexes = [];
		section.find('.swiper-container-initialized').each(function(){
			var swiperObj = $(this);
			var swiperInstance = swiperObj[0].swiper;
			that.vars.currentSwiperIndexes.push(swiperInstance.activeIndex);
		});
		if (frame.length > 0){
			$.ajax({
				type:'POST',
				url:$('meta[name="site-url"]').attr('content')+'/dashboard/cms/pages/field-settings/'+data.field+'/'+data.moduleKey+'/'+data.moduleKey+'/reload?page='+that.vars.fieldSettingsQueryObj.page+'&moduleName='+that.vars.fieldSettingsQueryObj.module,
				data:$('.editor', parent.document).find('form[id="page"]').serialize(),
				success:function(data){
					newSection = $(data.html);
					section.html(newSection.html());
					section.parents('.site').removeClass(function(index, className){
						return (className.match(/(^|\s)site--settings-\S+/g) || []).join(' ');
					}).addClass(data.siteClasses);
					that.updateModuleSettingsLink(section);
					app.reinit();
					if (frame.length){
						frame[0].contentWindow.app.reinit();
					}
					section.find('.swiper-container-initialized').each(function(index){
						var swiperObj = $(this);
						var swiperInstance = swiperObj[0].swiper;
						swiperInstance.slideTo(that.vars.currentSwiperIndexes[index], 0);
					});
				}
			});
		} else {
			app.reinit();
			if (frame.length){
				frame[0].contentWindow.app.reinit();
			}
		}
		if (!newSection){
			section.find('.swiper-container-initialized').each(function(index){
				var swiperObj = $(this);
				var swiperInstance = swiperObj[0].swiper;
				swiperInstance.slideTo(that.vars.currentSwiperIndexes[index], 0);
			});
		}
	},
	updateModuleSettingsLink:function(section){
		var that = this;
		var settingsButton = section.find('.edit_block__button--settings');
		that.vars.fieldSettingsQueryObj.page = settingsButton.attr('data-page');
		that.vars.fieldSettingsQueryObj.module = settingsButton.attr('data-module');
		var settingsHrefArr = settingsButton.attr('href').split('?');
		var queryStr = $.param(that.vars.fieldSettingsQueryObj);
		settingsButton.attr('href', settingsHrefArr[0]+'?'+queryStr).attr('data-page', that.vars.fieldSettingsQueryObj.page).attr('data-module', that.vars.fieldSettingsQueryObj.module);
	},
	enableAddModuleButton:function(button, data){
		var that = this;
		var item = button.closest('._05__item');
		var itemContainer = item.parent();
		var appsContainer = item.closest('.module__apps');
		item.remove();
		var itemLeftLength = itemContainer.children().length;
		if (itemLeftLength == 0){
			appsContainer.next().find('.button').removeClass('button--disabled');
			appsContainer.remove();
		}
		return false;
	},
	updateSticky:function(){
		var that = this;
		var stickyElement = $('._04__sidebar ul');
		if (typeof stickyElement.data('stickySidebar') !== 'undefined'){
			stickyElement.data('stickySidebar').updateSticky();
		}
	},
	reinit:function(){
		var that = this;
		that.addListener();
	}
};
app.modules.cms = new cms;
function froala(){}
froala.prototype = {
	init:function(){
		var that = this;
		that.addListener();
		var lang = $('html').attr('lang');

		$('textarea[data-rte]').each(function(){
			var textarea = $(this);
			var editorObjLength = textarea.prev('.fr-box').length;
			if (editorObjLength == 0 && !textarea.hasClass('fr-ready') && typeof textarea.parents('.sidebar__fields').html() === 'undefined'){
				textarea.addClass('fr-ready');
				var customOptions = $.parseJSON(textarea.attr('data-rte-options'));
				var editorOptions = {
					key:window.location.hostname == 'webomat-new.devlocal' ? 'XAG4eA2A3C8B7D7B5C-11vgakhgsC6goA-8F4ikyB-13D-13qrxiB3B9A6C7C2C4G5H3G3I3==' : 'GPD2tA5A7A1D4B1A1squJ-7zzC2arzvwzhB5D-16kC-11A2B2C2H2C9B3C1C6A1E1==',
					language:lang,
					attribution:false,
					htmlAllowComments:false,
					htmlExecuteScripts:false,
					tooltips:false,
					shortcutsHint:false,
					placeholderText:typeof textarea.attr('data-placeholder') !== 'undefined' ? textarea.attr('data-placeholder') : '',
					linkEditButtons:['linkEdit', 'linkStyle', 'linkRemove', 'linkOpen'],
					linkInsertButtons:['linkBack'],
					linkAlwaysNoFollow:false,
					charCounterCount:true
				};
				editorOptions = $.extend({}, editorOptions, customOptions);
				var editor = new FroalaEditor(textarea[0], editorOptions);
			}
		});
	},
	addListener:function(){
		var that = this;
	},
	reinit:function(){
		var that = this;
		that.init();
	}
};
app.modules.froala = new froala;
function blockPackages(){
	this.site = $('.site');
}
blockPackages.prototype = {
	init:function(){
		var that = this;
		that.addListener();

		$('.block--packages .packages__container').each(function(index){
			var swiperObj = $(this);
			var swiperInstance = new Swiper(swiperObj[0], {
				wrapperClass:'packages__wrapper',
				slideClass:'packages__slide',
				spaceBetween:20,
				slideActiveClass:'packages__slide--active',
				slideNextClass:'packages__slide--next',
				slidesPerView:2,
				pagination:{
					el:'.packages__pagination',
					type:'bullets',
					bulletClass:'bullet',
					bulletActiveClass:'bullet--active',
					modifierClass:'packages__pagination--',
					clickableClass:'packages__pagination--clickable',
					clickable:true
				},
				allowTouchMove:that.site.hasClass('site--mode-editor') ? false : true,
				breakpoints:{
					767:{
						slidesPerView:1,
						spaceBetween:20,
						allowTouchMove:that.site.hasClass('site--mode-editor') ? false : true
					},
					1023:{
						slidesPerView:2,
						spaceBetween:20,
						allowTouchMove:that.site.hasClass('site--mode-editor') ? false : true
					}
				}
			});
		});
	},
	addListener:function(){
		var that = this;
	}
};
app.modules.blockPackages = new blockPackages;
function table(){}
table.prototype = {
	init:function(){
		var that = this;
		that.addListener();
		that.initMobile();
	},
	addListener:function(){
		var that = this;

		$('input[type="checkbox"][name="check__all"]').each(function(){
			var checkAll = $(this);
			var tableCheckboxes = $('input[name="'+checkAll.attr('value')+'[]"]');
			checkAll.on({
				change:function(e){
					var countTableCheckboxes = tableCheckboxes.length;
					var countCheckedTableCheckboxes = $('input[name="'+checkAll.attr('value')+'[]"]:checked').length;
					if (countTableCheckboxes > countCheckedTableCheckboxes){
						tableCheckboxes.prop('checked', true);
						that.showActions(checkAll, tableCheckboxes);
					} else {
						tableCheckboxes.prop('checked', false);
						that.hideActions(checkAll, tableCheckboxes);
					}
				}
			});
			tableCheckboxes.on({
				change:function(e){
					var countTableCheckboxes = tableCheckboxes.length;
					var countCheckedTableCheckboxes = $('input[name="'+checkAll.attr('value')+'[]"]:checked').length;
					if (countCheckedTableCheckboxes > 0){
						that.showActions(checkAll, tableCheckboxes);
					} else {
						that.hideActions(checkAll, tableCheckboxes);
					}
				}
			});
		});
	},
	initMobile:function(){
		var that = this;
		if (app.vars.screenTablet !== true){
			$('.table, table').each(function(index){
				var table = $(this);
				var theadCell = [];
				table.find('.thead .th, thead th').each(function(){
					theadCell.push($(this).text());
				});
				table.find('.tbody .tr, tbody tr').each(function(){
					var tableRow = $(this);
					tableRow.find('.td, td').each(function(indexCell){
						var tableCell = $(this);
						if (indexCell in theadCell){
							tableCell.prepend('<b>'+theadCell[indexCell]+':</b> ');
						}
					});
				});
				table.find('.thead, thead').remove();
			});
		}
	},
	showActions:function(checkAll, tableCheckboxes){
		var that = this;
		checkAll.prop('checked', true);
		var tableCell = checkAll.parents('.th');
		if (typeof tableCell.attr('data-class') === 'undefined'){
			tableCell.attr('data-class', tableCell.attr('class'));
		}
		tableCell.attr('class', 'th col-xs-12');
		tableCell.nextAll().addClass('hidden');
		tableCell.find('.table__actions_col').addClass('table__actions_col--show');
		that.updateActionsLink(tableCell, checkAll);
	},
	hideActions:function(checkAll, tableCheckboxes){
		var that = this;
		checkAll.prop('checked', false);
		var tableCell = checkAll.parents('.th');
		tableCell.attr('class', tableCell.attr('data-class'));
		tableCell.removeAttr('data-class');
		tableCell.nextAll().removeClass('hidden');
		tableCell.find('.table__actions_col').removeClass('table__actions_col--show');
		that.updateActionsLink(tableCell, checkAll);
	},
	updateActionsLink:function(tableCell, checkAll){
		var that = this;
		var checkedIds = $('input[name="'+checkAll.attr('value')+'[]"]:checked').map(function(){
			return $(this).val();
		}).get();
		tableCell.find('a').each(function(){
			var action = $(this);
			var actionLink = action.attr('href');
			var actionLinkArr = actionLink.split('?');
			var actionLinkQueryObj = typeof actionLinkArr[1] !== 'undefined' ? $.getQueryParameters(actionLinkArr[1]) : {};
			delete actionLinkQueryObj['ids'];
			actionLinkQueryObj['ids'] = checkedIds.join(',');
			var actionNewQuery = app.getQueryString(actionLinkQueryObj, false);
			action.attr('href', actionLinkArr[0]+'?'+actionNewQuery);
		});
	},
	reinit:function(){
		var that = this;
		that.addListener();
	}
};
app.modules.table = new table;
function sortable(){
	this.vars = {
		sortInputValue:null
	}
}
sortable.prototype = {
	init:function(){
		var that = this;
		that.addListener();

		// init sortable
		$('[data-sortable]').each(function(){
			var sortable = $(this);
			sortable.sortable({
				//sort:true,
				delay:0,
				delayOnTouchOnly:false,
				touchStartThreshold:0,
				disabled:false,
				animation:300,
				handle:typeof sortable.attr('data-sortable-disable-handle') !== 'undefined' ? false : '.handle',
				group:typeof sortable.attr('data-group') !== 'undefined' ? $.parseJSON(sortable.attr('data-group')) : null,
				preventOnFilter:true,
				swapThreshold:1,
				invertSwap:true,
				invertedSwapThreshold:1,
				direction:'horizontal',
				forceFallback:true,
				fallbackOnBody:false,
				fallbackTolerance:0,
				dragoverBubble:false,
				removeCloneOnHide:true,
				emptyInsertThreshold:5,
				ghostClass:'sortable-ghost',
				onEnd:function(event){
					if (typeof sortable.attr('data-on-end') !== 'undefined'){
						var onEndArr = sortable.attr('data-on-end').split('.');
						app.modules[onEndArr[0]][onEndArr[1]](sortable, event);
					}
				}
			});
		});
	},
	addListener:function(){
		var that = this;

		// sort by input
		$('[data-sortable] input[name="sort"]').unbind().on({
			focus:function(){
				var sortValueField = $(this);
				that.vars.sortInputValue = sortValueField.val();
			},
			blur:function(){
				var sortValueField = $(this);
				if (sortValueField.val() != that.vars.sortInputValue){
					var sortableObj = sortValueField.closest('[data-sortable]');
					var sortable = sortableObj.data('sortable');
					var sortableDragSelector = sortable.options.draggable;
					var dragItem = sortValueField.closest(sortableObj.find(sortableDragSelector));
					var ids = [];
					sortableObj.children().each(function(index){
						var sortableChild = $(this);
						ids.push(sortableChild.attr('data-id'));
					});
					$.ajax({
						type:'POST',
						url:sortableObj.attr('data-sortable-sort-url'),
						data:'id='+dragItem.attr('data-id')+'&function=custom&new_sort_id='+sortValueField.val()+'&ids='+JSON.stringify(ids),
						success:function(data){
							$.each(data.items, function(index, value){
								sortableObj.find('[data-id="'+index+'"]').attr('data-sort', value).find('.table__sort input').val(value);
							});
							[].map.call(sortableObj[0].children, Object).sort(function(a, b){
								return +a.getAttribute('data-sort').match(/\d+/) - +b.getAttribute('data-sort').match(/\d+/);
							}).forEach(function(elem){
								sortableObj[0].appendChild(elem);
							});
						}
					});
				}
				that.vars.sortInputValue = sortValueField.val();
			}
		});
	},
	sort:function(sortable, event){
		var that = this;
		if (event.oldIndex != event.newIndex){
			var beforeOrAfter = null;
			var beforeOrAfterId = null;
			var prevItem = $(event.item).prev();
			var nextItem = $(event.item).next();
			if (nextItem.length > 0){
				beforeOrAfter = 'before';
				beforeOrAfterId = nextItem.attr('data-id');
			} else {
				beforeOrAfter = 'after';
				beforeOrAfterId = prevItem.attr('data-id');
			}
			var ids = [];
			sortable.children().each(function(index){
				var sortableChild = $(this);
				ids.push(sortableChild.attr('data-id'));
			});
			$.ajax({
				type:'POST',
				url:sortable.attr('data-sortable-sort-url'),
				data:'id='+$(event.item).attr('data-id')+'&function='+beforeOrAfter+'&position_entity_id='+beforeOrAfterId+'&ids='+JSON.stringify(ids),
				success:function(data){
					$.each(data.items, function(index, value){
						sortable.find('[data-id="'+index+'"] .table__sort input').val(value);
					});
					that.addListener();
				}
			});
		}
	},
	reinit:function(){
		var that = this;
		that.init();
	}
};
app.modules.sortable = new sortable;
function paging(){
	this.vars = {
		itemsPerPage:10
	}
}
paging.prototype = {
	init:function(){
		var that = this;
		var pagination = $('.paging');
		that.addListener();
		that.build(pagination, pagination.attr('data-total'), pagination.attr('data-pageLimit'));
	},
	addListener:function(){
		var that = this;
	},
	build:function(pagingContainer, itemsCount, pageLimit){
		var that = this;
		var itemsCount = parseInt(itemsCount),
			pageLimit = parseInt(pageLimit),
			pagingUrl = typeof pagingContainer.attr('data-url') !== 'undefined' ? pagingContainer.attr('data-url') : window.location.pathname,
			pagingHtml = '<ul>',
			queryParams = $.getQueryParameters(typeof pagingContainer.attr('data-url') !== 'undefined' ? pagingContainer.attr('data-url') : null),
			pagingPages = Math.ceil(itemsCount/pageLimit);

		pagingContainer.pagination({
			items:itemsCount,
			itemsOnPage:pagingContainer.attr('data-pagelimit'),
			currentPage:typeof queryParams.page == 'undefined' ? 1 : queryParams.page,
			hrefTextPrefix:pagingUrl+(pagingUrl.indexOf('?') >= 0 ? '&' : '?')+app.getQueryString({page:''}),
			selectOnClick:false,
			prevText:typeof window['transGlobal'] !== 'undefined' && typeof window['transGlobal']['prev'] !== 'undefined' ? window['transGlobal']['prev'] : 'prev',
			nextText:typeof window['transGlobal'] !== 'undefined' && typeof window['transGlobal']['next'] !== 'undefined' ? window['transGlobal']['next'] : 'next',
			ellipsePageSet:false,
			edges:2,
			displayedPages:app.vars.screenTablet ? 5 : 3,
			onPageClick:function(pageNumber, event){
				if (typeof pagingContainer.attr('data-ajax') !== 'undefined'){
					var newUrl = decodeURIComponent(event.currentTarget.href);
					var container = $(pagingContainer.attr('data-content-selector'));
					$.ajax({
						type:'GET',
						url:newUrl,
						data:'',
						success:function(data){
							var dataObj = $('<div>'+data+'</div>');
							var dataObjContainer = dataObj.find(pagingContainer.attr('data-content-selector'));
							container.html(dataObjContainer.html());
							app.reinit();
						}
					});
					return false;
				}
			}
		});
	},
	reinit:function(){
		var that = this;
		that.init();
	}
};
app.modules.paging = new paging;
function editor(){
	this.editorObj = $('.editor');
	this.frame = $('#editor');
	this.frameContent = $('#frame-content-placeholder');
	this.selectPage = $('.topbar__select_page');
	this.screenSizeMenu = $('.topbar__screensize');
	this.addBlockButton = $('.add_block__button');
	this.addBlockItemButton = $('.add_block_item__button');
	this.removeBlockKey = null;
	this.settingsBlockKey = null;
	this.removeBlockItemKey = null;
}
editor.prototype = {
	init:function(){
		var that = this;

		// check if live editor is available
		that.checkAvailable();
		$(window).on('load resize', function(e){
			that.checkAvailable();
		});

		// load editor
		if (typeof that.frame.html() !== 'undefined'){
			var frameLoader = setInterval(function(){
				if (window.editorLoaded){
					that.frameContent = that.frame.contents();
					that.addListener();
					that.initInlineEditor();
					that.loaded();
					clearInterval(frameLoader);
				}
			}, 100);
		}

		// init editable fields
		that.initInlineEditor();

		// init sidebar block toggle
		$('.sidebar__block--toggle').each(function(){
			var sidebarBlock = $(this);
			sidebarBlock.find('.sidebar__block_header .icon').remove();
			sidebarBlock.find('.sidebar__block_header').append('<span class="icon icon--arrow-down"></span>');
		});
	},
	addListener:function(){
		var that = this;

		// toggle sidebar blocks
		$('.sidebar__block--toggle .sidebar__block_header').unbind().on({
			click:function(){
				var blockHeader = $(this);
				var block = blockHeader.closest('.sidebar__block');
				block.toggleClass('sidebar__block--toggle-open');
			}
		});

		// switch sidebar pages
		$('a[data-page][data-move-module]').unbind().on({
			click:function(){
				var button = $(this);
				var currentPage = button.closest('.sidebar__page');
				var newPage = $('.sidebar__page[data-page="'+button.attr('data-page')+'"]');
				if (typeof button.attr('data-module-key') !== 'undefined'){
					var section = that.frameContent.find('section[data-module-key="'+(button.attr('data-module-key'))+'"]');
					that.frameContent.find('html, body').animate({
						scrollTop:section.offset().top
					}, 800, 'easeOutCubic');
				} else {
					currentPage.removeClass('sidebar__page--open');
					newPage.addClass('sidebar__page--open');
					app.modules.tooltip.init();
				}
				return false;
			}
		});

		// toggle sidebar
		$('.topbar__col--burger i').unbind().on({
			click:function(){
				var burgerIcon = $(this);
				var burger = burgerIcon.closest('.burger');
				var sidebar = $('.editor__sidebar');
				burger.toggleClass('selected');
				sidebar.toggleClass('editor__sidebar--show');
			}
		});

		// switch screen size
		that.screenSizeMenu.find('a').unbind().on({
			click:function(){
				var screenOption = $(this);
				var screen = screenOption.attr('data-size');
				that.frame.removeClass('frame--mobile frame--tablet frame--desktop').addClass('frame--'+screen);
				//that.frame.attr('src', that.frame.attr('src'));
				that.screenSizeMenu.find('a').removeClass('selected');
				screenOption.addClass('selected');
				return false;
			}
		});

		// add block
		that.frameContent.find('.add_block__button').unbind().on({
			click:function(){
				var addBlockButton = $(this);
				app.modules.overlay.prepare(addBlockButton);
				return false;
			}
		});

		// add block item
		that.frameContent.find('.edit_block_item__button--add').unbind().on({
			click:function(){
				var addBlockItemButton = $(this);
				app.modules.form.submitAjaxButton(addBlockItemButton);
				return false;
			}
		});

		// sort block
		that.frameContent.find('.edit_block__button--forward, .edit_block__button--back').unbind().on({
			click:function(){
				var editBlockButton = $(this);
				var editBlockKey = editBlockButton.attr('data-module-key');

				// sort block
				var block = editBlockButton.closest('section');
				var index = block.index();
				if (editBlockButton.hasClass('edit_block__button--back')){
					if (index > 0){
						block.prev().insertAfter(block);
					} else {
						return false;
					}
				} else {
					if (index+1 < block.parent().children().length){
						block.next().insertBefore(block);
					} else {
						return false;
					}
				}

				// sort editor block
				var editorBlock = $('.sidebar__fields .fields__block[data-module-key="'+editBlockKey+'"]');
				var index = editorBlock.index();
				if (editBlockButton.hasClass('edit_block__button--back')){
					if (index > 0){
						editorBlock.prev().insertAfter(editorBlock);
					} else {
						return false;
					}
				} else {
					if (index+1 < editorBlock.parent().children().length){
						editorBlock.next().insertBefore(editorBlock);
					} else {
						return false;
					}
				}

				// update site
				that.updateSite(block.parents('.site'));

				// reinit
				app.reinit();
				if (that.frame.length){
					that.frame[0].contentWindow.app.reinit();
				}
				return false;
			}
		});

		// sort block item
		that.frameContent.find('.edit_block_item__button--forward, .edit_block_item__button--back').unbind().on({
			click:function(){
				var editBlockItemButton = $(this);
				var itemFieldName = editBlockItemButton.attr('data-item-field-name');

				// sort item
				var item = editBlockItemButton.closest('[data-module-item]');
				var index = item.index();
				if (editBlockItemButton.hasClass('edit_block_item__button--back')){
					if (index > 0){
						item.prev().insertAfter(item);
					} else {
						return false;
					}
				} else {
					if (index+1 < item.parent().children().length){
						item.next().insertBefore(item);
					} else {
						return false;
					}
				}

				// sort editor item
				var editorItem = $('.sidebar__fields .form__list_container input[name="'+itemFieldName+'"]').parent();
				var index = editorItem.index();
				if (editBlockItemButton.hasClass('edit_block_item__button--back')){
					if (index > 0){
						editorItem.prev().insertAfter(editorItem);
					} else {
						return false;
					}
				} else {
					if (index+1 < editorItem.parent().children().length){
						editorItem.next().insertBefore(editorItem);
					} else {
						return false;
					}
				}

				// reinit
				app.reinit();
				if (that.frame.length){
					that.frame[0].contentWindow.app.reinit();
				}
				return false;
			}
		});

		// remove block
		that.frameContent.find('.edit_block__button--delete').unbind().on({
			click:function(){
				var removeBlockButton = $(this);
				that.removeBlockKey = removeBlockButton.attr('data-module-key');
				app.modules.overlay.prepare(removeBlockButton);
				return false;
			}
		});

		// remove block item
		that.frameContent.find('.edit_block_item__button--delete').unbind().on({
			click:function(){
				var removeBlockItemButton = $(this);
				that.removeBlockItemKey = removeBlockItemButton.attr('data-item-field-name');
				app.modules.overlay.prepare(removeBlockItemButton);
				return false;
			}
		});

		// block settings
		that.frameContent.find('.edit_block__button--settings').unbind().on({
			click:function(){
				var settingsBlockButton = $(this);
				that.settingsBlockKey = settingsBlockButton.attr('data-module-key');
				app.modules.overlay.prepare(settingsBlockButton);
				settingsBlockButton.blur();
				return false;
			}
		});

		// block change mode
		that.frameContent.find('.edit_block__button--mode').unbind().on({
			click:function(){
				var changeModeBlockButton = $(this);
				app.modules.overlay.prepare(changeModeBlockButton);
				changeModeBlockButton.blur();
				return false;
			}
		});

		// edit logo
		that.frameContent.find('.edit_field--logo').unbind().on({
			click:function(){
				app.modules.overlay.prepare($(this));
				return false;
			}
		});

		// edit images
		that.frameContent.find('.edit_field--image').unbind().on({
			click:function(){
				app.modules.overlay.prepare($(this));
				return false;
			}
		});

		// edit gallery
		that.frameContent.find('.edit_field--gallery').unbind().on({
			click:function(){
				app.modules.overlay.prepare($(this));
				return false;
			}
		});

		// edit select
		that.frameContent.find('.edit_field--select').unbind().on({
			click:function(){
				app.modules.overlay.prepare($(this));
				return false;
			}
		});

		// edit link
		that.frameContent.find('.edit_field--link').unbind().on({
			click:function(){
				var linkButton = $(this);
				var editorButton = $('.sidebar__fields input[name="'+linkButton.attr('data-field')+'[text]"]').prev();
				app.modules.overlay.prepare(editorButton);
				return false;
			}
		});

		// handle editor links
		that.frameContent.find('a[href$=preview]').unbind().on({
			click:function(){
				var link = $(this);
				var href = link.attr('href').replace('/preview/preview', '');
				var hrefArr = href.split('/');
				var parentDocument = parent.document;
				var id = hrefArr[hrefArr.length-1];
				var newEditorUrl = parentDocument.location.origin+parentDocument.location.pathname+'?page='+id;
				parentDocument.location.href = newEditorUrl;
				return false;
			}
		});

		// show/hide field
		that.frameContent.find('.edit_field_visibility').unbind().on({
			click:function(){
				var visibilityButton = $(this);
				var item = visibilityButton.closest('[data-module-item]');
				var editPrimaryField = visibilityButton.closest('.edit_primary_field');
				var formFieldWrapper = visibilityButton.closest('.edit_field_wrapper').find('.edit_field');
				var formFieldOuterWrapper = formFieldWrapper.closest('[data-visible-wrapper]');
				var fieldName = visibilityButton.attr('data-field-name');
				var fieldNameArr = fieldName.split('[value]');
				var shortFieldName = fieldNameArr[fieldNameArr.length-1];
				var fieldNameString = shortFieldName.replace('[', '').replace(']', '');
				var newFieldName = fieldNameArr.slice(0, fieldNameArr.length-1).join('[value]');
				newFieldName = newFieldName+'[hidden][';
				newFieldName = newFieldName+(shortFieldName.replace(/\[/g, '').replace(/\]/g, ''))+']';
				var section = visibilityButton.closest('section');
				var pageForm = $('#page');
				var fieldBlock = $('.sidebar__fields .fields__block[data-module-key="'+section.attr('data-module-key')+'"]');
				if (formFieldWrapper.hasClass('edit_field--hidden')){
					console.log('show');
					formFieldWrapper.removeClass('edit_field--hidden');
					fieldBlock.find('input[name="'+newFieldName+'"]').remove();
					if (typeof formFieldOuterWrapper.html() !== 'undefined'){
						formFieldOuterWrapper.removeClass('edit_field_visibility_wrapper--hidden');
					}
					if (typeof item.html() !== 'undefined'){
						var itemVisibilityField = item.find('[data-field-'+fieldNameString+']');
						if (typeof itemVisibilityField.html() !== 'undefined'){
							itemVisibilityField.removeClass('edit_field_visibility_item--hidden');
						}
					}
				} else {
					console.log('hide');
					formFieldWrapper.addClass('edit_field--hidden');
					fieldBlock.append('<input type="hidden" name="'+newFieldName+'" value="1" />');
					if (typeof formFieldOuterWrapper.html() !== 'undefined'){
						formFieldOuterWrapper.addClass('edit_field_visibility_wrapper--hidden');
					}
					if (typeof item.html() !== 'undefined'){
						var itemVisibilityField = item.find('[data-field-'+fieldNameString+']');
						if (typeof itemVisibilityField.html() !== 'undefined'){
							itemVisibilityField.addClass('edit_field_visibility_item--hidden');
						}
					}
				}				
				if (typeof editPrimaryField.html() !== 'undefined'){
					that.frameContent.find('.tooltip').remove();
					$.ajax({
						type:'POST',
						url:$('meta[name="site-url"]').attr('content')+'/dashboard/cms/pages/field-settings/block/'+section.attr('data-module-key')+'/'+section.attr('data-module-key')+'/apply',
						data:$('#page').serialize(),
						success:function(data){
							app.modules.cms.applyFieldSettings(pageForm, data);
						}
					});
				}
				return false;
			}
		});

		// update/publish page
		$('button[form="page"][name="action"]').unbind().on({
			click:function(){
				var button = $(this);
				var form = $('#page');
				var actionField = form.find('input[name="action"]');
				actionField.val(button.attr('value'));
			}
		});
	},
	initInlineEditor:function(){
		var that = this;
		var lang = $('html').attr('lang');

		// custom buttons
		FroalaEditor.DefineIcon('close', {NAME:'close', SVG_KEY:'close'});
		FroalaEditor.RegisterCommand('close', {
			title:'Close toolbar',
			focus:false,
			undo:false,
			refreshAfterCallback:false,
			callback:function(){
				this.selection.clear();
				this.toolbar.hide();
			}
		});

		// init editor
		$('.editable, .edit_field--text, .edit_field--textarea').each(function(){
			var textarea = $(this);
			if (!textarea.hasClass('fr-box')){
				var customOptions = $.parseJSON(textarea.attr('data-rte-options'));
				var editorOptions = {
					key:window.location.hostname == 'webomat-new.devlocal' ? 'XAG4eA2A3C8B7D7B5C-11vgakhgsC6goA-8F4ikyB-13D-13qrxiB3B9A6C7C2C4G5H3G3I3==' : 'GPD2tA5A7A1D4B1A1squJ-7zzC2arzvwzhB5D-16kC-11A2B2C2H2C9B3C1C6A1E1==',
					language:lang,
					attribution:false,
					toolbarInline:true,
					//toolbarContainer:'.topbar__col--editor',
					htmlAllowComments:false,
					htmlExecuteScripts:false,
					tooltips:false,
					shortcutsHint:false,
					placeholderText:typeof textarea.attr('data-placeholder') !== 'undefined' ? textarea.attr('data-placeholder') : '',
					linkEditButtons:['linkEdit', 'linkStyle', 'linkRemove', 'linkOpen'],
					linkInsertButtons:['linkBack'],
					linkAlwaysNoFollow:false,
					events:{
						initialized:function(){
							//
						},
						/*
						'toolbar.show':function(){
							$('.topbar__col').not('.topbar__col--editor').addClass('topbar__col--invisible');
							$('.topbar__col--editor').removeClass('topbar__col--invisible');
						},
						'toolbar.hide':function(){
							$('.topbar__col').not('.topbar__col--editor').removeClass('topbar__col--invisible');
							$('.topbar__col--editor').addClass('topbar__col--invisible');
						},
						*/
						contentChanged:function(){
							var box = this.$box;
							if (typeof box.attr('data-field') !== 'undefined'){
								$('.editor', parent.document).find('[name="'+(box.attr('data-field'))+'"]').val(this.$el[0].innerHTML);
							}
						}
					}
				};
				editorOptions = $.extend({}, editorOptions, customOptions);
				var editor = new FroalaEditor(textarea[0], editorOptions);
			}
		});
	},
	addModule:function(button, data){
		var that = this;
		that.frame = $('#editor');

		// reload assets
		that.reloadAssets();

		if (typeof that.frameContent.find('#empty-section').html() !== 'undefined'){
			var section = that.frameContent.find('main #empty-section');
			var editorListItem = $('.sidebar__list #empty-list-item a');
			var fieldBlock = $('.sidebar__fields #empty-field-block');
		} else {
			var section = that.frameContent.find('main section[data-module-key="'+data.moduleKey+'"]');
			var editorListItem = $('.sidebar__list a[data-module-key="'+data.moduleKey+'"]');
			var fieldBlock = $('.sidebar__fields .fields__block[data-module-key="'+data.moduleKey+'"]');
		}

		// insert section
		section.after(data.htmlEditor);

		// insert editor list item
		editorListItem.parent().after(data.editorListItem);

		// insert fields
		fieldBlock.after('<div class="fields__block" data-module-key="'+data.newModuleKey+'">'+data.htmlBackend+'</div>');

		if (typeof that.frameContent.find('#empty-section').html() !== 'undefined'){
			that.frameContent.find('#empty-section').remove();
			$('#empty-list-item, #empty-field-block').remove();
		}

		// reinit
		app.reinit();
		if (that.frame.length){
			that.frame[0].contentWindow.app.reinit();
		}
	},
	addModuleItem:function(button, data){
		var that = this;
		var item = button.closest('[data-module-item]');
		that.frame = $('#editor');

		// insert item
		//$(data.htmlEditor).insertAfter(item);
		item.parent().prepend(data.htmlEditor);

		// insert editor item
		var fieldBlockList = $('.sidebar__fields .fields__block[data-module-key="'+data.moduleKey+'"] .form__list_container[data-list="'+data.listName+'"]');
		fieldBlockList.prepend(data.htmlBackend);

		// reinit
		app.reinit();
		if (that.frame.length){
			that.frame[0].contentWindow.app.reinit();
		}
	},
	sortContentBlock:function(sortable, event){
		var that = this;

		// sort section
		var section = that.frameContent.find('main section').eq(event.oldIndex);
		if (that.frameContent.find('main section').length > 1){
			if (event.newIndex == 0){
				$(section.detach()).insertBefore(that.frameContent.find('main section').eq(0));
			} else {
				$(section.detach()).insertAfter(that.frameContent.find('main section').eq(event.newIndex-1));
			}
		}

		// sort fields
		var fieldBlock = $('.sidebar__fields .fields__block').eq(event.oldIndex);
		if (that.frameContent.find('main section').length > 1){
			if (event.newIndex == 0){
				$(fieldBlock.detach()).insertBefore($('.sidebar__fields .fields__block').eq(0));
			} else {
				$(fieldBlock.detach()).insertAfter($('.sidebar__fields .fields__block').eq(event.newIndex-1));
			}
		}
	},
	removeContentBlock:function(button){
		var that = this;
		app.modules.overlay.hideIfOpen();
		if (that.removeBlockKey){
			var section = that.frameContent.find('main section[data-module-key="'+that.removeBlockKey+'"]');
			
			// block size
			var blocks = section.parent().find('section');
			if (blocks.length == 1){
				$.toaster({
					priority:'warning',
					message:trans.editor.at_least_one_block_needed
				});
				return false;
			}

			// remove section
			section.remove();

			// remove editor list item
			var editorListItem = $('.sidebar__list a[data-module-key="'+that.removeBlockKey+'"]');
			editorListItem.parent().remove();

			// remove fields
			var fieldBlock = $('.sidebar__fields .fields__block[data-module-key="'+that.removeBlockKey+'"]');
			fieldBlock.remove();

			// update site
			that.updateSite(that.frameContent.find('.site'));
		}
	},
	removeModuleItem:function(button){
		var that = this;
		app.modules.overlay.hideIfOpen();
		if (that.removeBlockItemKey){
			var removeBlockItemButton = that.frameContent.find('.edit_block_item__button--delete[data-item-field-name="'+that.removeBlockItemKey+'"]');
			var item = removeBlockItemButton.closest('[data-module-item]');

			// item size
			var items = item.parent().find('[data-module-item]');
			if (items.length == 1){
				$.toaster({
					priority:'warning',
					message:trans.editor.at_least_one_item_needed
				});
				return false;
			}
			
			// remove item
			item.remove();

			// remove editor item
			var editorItem = $('.sidebar__fields .form__list_container input[name="'+that.removeBlockItemKey+'"]').parent();
			editorItem.remove();

			// reinit
			app.reinit();
			if (that.frame.length){
				that.frame[0].contentWindow.app.reinit();
			}
		}

	},
	reloadAssets:function(){
		var that = this;
		var pageStyles = that.frameContent.find('#page-styles');
		pageStyles.attr('href', pageStyles.attr('href')+'&nv='+(new Date().getTime()));
		var pageJsVendor = that.frameContent.find('#page-js-vendor');
		var pageJsVendorSrc = pageJsVendor.attr('src')+'&nv='+(new Date().getTime());
		pageJsVendor.attr('src', pageJsVendorSrc);
		var pageJsScripts = that.frameContent.find('#page-js-scripts');
		var pageJsScriptsSrc = pageJsScripts.attr('src')+'&nv='+(new Date().getTime());
		pageJsScripts.attr('src', pageJsScriptsSrc);
		if (typeof $('#editor')[0] !== 'undefined'){
			$('#editor')[0].contentWindow.app.modules.editor.reloadJavascript(pageJsVendorSrc, pageJsScriptsSrc);
		}
	},
	reloadJavascript:function(vendor, scripts){
		var that = this;
		$.getScript(vendor, function(data, textStatus, jqxhr){
			$.getScript(scripts, function(data, textStatus, jqxhr){
				$('section.unvisible').removeClass('unvisible');
			});
		});
	},
	switchPage:function(select){
		var that = this;
		
		var selectedPageValue = select.val();
		if (selectedPageValue != ''){
			var selectUrl = window.location.origin+window.location.pathname+'?page='+selectedPageValue;
			/*
			History.pushState({
				mode:'sleep'
			}, null, selectUrl);
			that.frame.attr('src', that.frame.attr('data-url').replace('/id/', '/'+selectedPageValue+'/'))
			*/
			window.location.href = selectUrl;
			return false;
		}
	},
	loaded:function(){
		var that = this;
		var editorLoading = $('.editor__loading');
		editorLoading.addClass('editor__loading--hide');
	},
	checkAvailable:function(){
		var that = this;
		var warningMessage = $('.editor__warning');
		var viewportWidth = app.getViewport('width');
		if (viewportWidth < 1024){
			warningMessage.addClass('editor__warning--show');
		} else {
			warningMessage.removeClass('editor__warning--show');
		}
	},
	switchMode:function(button){
		var that = this;
		var form = $('#page');
		var actionField = form.find('input[name="action"]');
		var callbackModuleField = form.find('input[name="callbackModule"]');
		var callbackFunctionField = form.find('input[name="callbackFunction"]');
		actionField.val('update');
		callbackModuleField.val('editor');
		callbackFunctionField.val('redirectToExpertMode');
		button.addClass('button--disabled').append('<span class="loader"></div>');
		form.submit();
		return false;
	},
	redirectToExpertMode:function(form, data){
		var that = this;
		var button = $('#confirm .button--confirm');
		button.removeClass('button--disabled');
		button.find('.loader').remove();
		button.find('.icon').removeClass('hidden');
		if (jQuery().dirtyForms){
			form.dirtyForms('setClean');
		}
		window.location.href = pageLinkExpertMode;
	},
	updateSite:function(site){
		var pageId = site.find('main section:first-child .edit_block__button--settings').attr('data-page');
		var that = this;
		$.ajax({
			type:'POST',
			url:$('meta[name="site-url"]').attr('content')+'/dashboard/cms/pages/'+pageId+'/get-site-settings',
			data:$('.editor', parent.document).find('form[id="page"]').serialize(),
			success:function(data){
				// update site classes
				site.removeClass(function(index, className){
					return (className.match(/(^|\s)site--settings-\S+/g) || []).join(' ');
				}).addClass(data.siteClasses);
			}
		});
	},
	reinit:function(){
		var that = this;
		that.addListener();
		that.initInlineEditor();
	}
};
app.modules.editor = new editor;
function menu(){
	this.menuContainer = $('#menu-container');
	this.menuSaveButton = $('#menu-save-button');
	this.emptyMessageContainer = $('#menu-empty-message');
	this.menuItemSettings = $('#menu-item-settings');
	this.selectPage = $('#select-page');
	this.items = [];
	this.vars = {
		itemSelector:'.panel__block',
		menuSettingsItem:null
	}
}
menu.prototype = {
	init:function(){
		var that = this;
		that.addListener();
	},
	addListener:function(){
		var that = this;

		// edit menu item
		that.menuContainer.find('.block__heading .edit').unbind().on({
			click:function(){
				var menuSettingsItem = $(this).closest(that.vars.itemSelector);
				that.vars.menuSettingsItem = menuSettingsItem;
				that.menuItemSettings.find('.selectized').each(function(){
	                var selectizedField = $(this);
	                if (selectizedField[0].selectize){
	                    selectizedField[0].selectize.destroy();
	                }
	            });
	            that.menuItemSettings.find('form')[0].reset();
				that.menuItemSettings.find('form input[name="text"]').val(menuSettingsItem.find('> input[name="menu_item_text"]').val());
				that.menuItemSettings.find('form select[name="target"]').val(menuSettingsItem.find('> input[name="menu_item_target"]').val());
	            that.menuItemSettings.find('form select[name="model"]').val(menuSettingsItem.find('> input[name="menu_item_id"]').val() != '' ? 'page' : (menuSettingsItem.find('> input[name="menu_item_route"]').val() != '' ? 'route' : 'custom'));
	            that.menuItemSettings.find('form input[name="link"]').val(menuSettingsItem.find('> input[name="menu_item_link"]').val());
	            if (menuSettingsItem.find('> input[name="menu_item_id"]').val() != ''){
	            	that.menuItemSettings.find('form select[name="id_page"]').find('option').remove().end().append(new Option(menuSettingsItem.find('> .block__heading .expand .caption').text(), menuSettingsItem.find('> input[name="menu_item_id"]').val()));
	            }
	            that.menuItemSettings.find('form select[name="id_page"]').val(menuSettingsItem.find('> input[name="menu_item_id"]').val());
	            that.menuItemSettings.find('form select[name="id_route"]').val(menuSettingsItem.find('> input[name="menu_item_route"]').val());
	            that.menuItemSettings.find('form input[name="extension"]').val(menuSettingsItem.find('> input[name="menu_item_link_extension"]').val());
	            app.modules.form.reinit();
				app.modules.overlay.show('inline', 'menu-item-settings', undefined, true);
				return false;
			}
		});

		// update menu item
		that.menuItemSettings.find('.button--submit').unbind().on({
			click:function(e){
				var isValid = that.menuItemSettings.find('form').valid();
				if(!isValid) {
					e.preventDefault();
				} else {
					that.vars.menuSettingsItem.find('> input[name="menu_item_text"]').val(that.menuItemSettings.find('form input[name="text"]').val());
					that.vars.menuSettingsItem.find('> .block__heading .expand .caption').text(that.menuItemSettings.find('form input[name="text"]').val());
					that.vars.menuSettingsItem.find('> input[name="menu_item_target"]').val(that.menuItemSettings.find('form select[name="target"]').val());
					that.vars.menuSettingsItem.find('> input[name="menu_item_id"]').val(that.menuItemSettings.find('form select[name="model"]').val() == 'page' ? that.menuItemSettings.find('form select[name="id_page"]').val() : '');
					that.vars.menuSettingsItem.find('> input[name="menu_item_route"]').val(that.menuItemSettings.find('form select[name="model"]').val() == 'route' ? that.menuItemSettings.find('form select[name="id_route"]').val() : '');
					that.vars.menuSettingsItem.find('> input[name="menu_item_link"]').val(that.menuItemSettings.find('form select[name="model"]').val() == 'custom' ? that.menuItemSettings.find('form input[name="link"]').val() : '');
					that.vars.menuSettingsItem.find('> input[name="menu_item_link_extension"]').val(that.menuItemSettings.find('form input[name="extension"]').val());
					app.modules.overlay.hideIfOpen();
				}
				return false;
			}
		});

		// remove menu item
		that.menuContainer.find('.block__heading .remove').on({
			click:function(){
				var menuSettingsItem = $(this).closest(that.vars.itemSelector);
				if (that.menuContainer.children().length == 0){
					that.emptyMessageContainer.removeClass('hidden');
				}
				return false;
			}
		});

		// save menu
		that.menuSaveButton.unbind().on({
			click:function(){
				var thisButton = $(this);
				if (!thisButton.hasClass('button--disabled')){
					thisButton.addClass('button--disabled').append('<span class="loader"></div>');
					that.items = [];
					that.items.push(that.parseItems(that.menuContainer));
					$.ajax({
						type:'POST',
						url:thisButton.attr('href'),
						data:'menu='+encodeURIComponent(JSON.stringify(that.items)),
						success:function(data){
							thisButton.removeClass('button--disabled');
							thisButton.find('.loader').remove();
							thisButton.find('.icon').removeClass('hidden');
							$.toaster({
								priority:'success',
								message:data.msg
							});
						}
					});
				}
				return false;
			}
		});
	},
	addPage:function(select){
		var that = this;
		if (select.val() != ''){
			$.ajax({
				type:'POST',
				url:select.attr('data-callback-on-change-url'),
				data:'page='+select.val(),
				success:function(data){
					that.pageAdded(null, data);
				}
			});
		}
	},
	pageAdded:function(button, data){
		var that = this;
		var select = that.selectPage.find('select');
		select.data('selectize').clear();
		that.emptyMessageContainer.addClass('hidden');
		that.menuContainer.prepend(data.html);
		app.reinit();
		that.addListener();
	},
	parseItems:function(element){
		var that = this;
		var items = [];
		element.children('.panel__block').each(function(index, value){
			var subElement = $(this);
			var item = {
				'id':subElement.find('input[name="menu_item_id"]').val(),
				'route':subElement.find('input[name="menu_item_route"]').val(),
				'text':subElement.find('input[name="menu_item_text"]').val(),
				'target':subElement.find('input[name="menu_item_target"]').val(),
				'link':subElement.find('input[name="menu_item_link"]').val(),
				'link_extension':subElement.find('input[name="menu_item_link_extension"]').val(),
				'children':[]
			};
			if (subElement.find('.panel__blocks').children('.panel__block').length > 0){
				item.children = that.parseItems(subElement.find('> .block__body > .panel__blocks'));
			}
			items.push(item);
		});
		return items;
	},
	changeMenu:function(select){
		var that = this;
		window.location.href = select.val();
	},
	resetItemSettings:function(overlay){
		var that = this;
		that.vars.menuSettingsItem = null;
	}
};
app.modules.menu = new menu;
function domain(){}
domain.prototype = {
	init:function(){
		var that = this;
		that.addListener();
	},
	addListener:function(){
		var that = this;

		// click popup link
		$('[data-popup]').unbind().on({
			click:function(){
				var popupLink = $(this);
				var popupStr = popupLink.attr('data-popup');
				var popupObj = $.parseJSON(popupStr);
				var onClose = popupObj.onClose.split('.');

				var popup = window.open(popupObj.url, '', 'width=850, height=650');
				var popupTick = setInterval(function(){
					if (popup.closed){
						clearInterval(popupTick);
						app.modules[onClose[0]][onClose[1]](popupLink);
					}
				}, 250);
				return false;
			}
		});
	},
	verifyConnection:function(popupLink){
		var that = this;
		if (typeof popupLink !== 'undefined'){
			var popupStr = popupLink.attr('data-popup');
			var popupObj = $.parseJSON(popupStr);
			window.location.href = popupObj.callbackUrl;
		} else {
			//
		}
	},
	reinit:function(){
		var that = this;
		that.init();
	}
};
app.modules.domain = new domain;
function gallery(){
	this.galleryForm = $('form[name="gallery_selection"]');
	this.galleryBody = $('._08__body');
	this.galleryEmpty = $('._08__empty');
	this.gallerySelection = $('._08__selection');
}
gallery.prototype = {
	init:function(){
		var that = this;
		that.addListener();
	},
	addListener:function(){
		var that = this;

		// select media item
		$('._07__tile--gallery-selector').unbind().on({
			click:function(){
				var item = $(this);
				if (item.hasClass('_07__tile--gallery-selected')){
					that.removeItem(item.attr('data-id'));
				} else {
					that.addItem(item);
				}
				return false;
			}
		});

		// remove media item
		$('._07__tile--gallery-item .tile__remove').unbind().on({
			click:function(){
				var removeButton = $(this);
				var item = removeButton.closest('._07__tile');
				that.removeItem(item.attr('data-id'));
				return false;
			}
		});
	},
	addItem:function(item){
		var that = this;
		that.galleryForm = $('form[name="gallery_selection"]');
		that.galleryBody = $('._08__body');
		that.galleryEmpty = $('._08__empty');
		that.gallerySelection = $('._08__selection');
		var itemLength = $('._07__tile--gallery-item[data-id="'+item.attr('data-id')+'"]').length;
		var galleryItemsLength = $('._07__tile--gallery-item').length;
		if (itemLength > 0 && !that.galleryBody.hasClass('_08__body-no-sidebar')){
			that.removeItem(item.attr('data-id'));
		} else {
			if (itemLength > 0 && that.galleryBody.hasClass('_08__body-no-sidebar')){
				that.removeItem(item.attr('data-id'));
			}
			var gridItem = item.parent();
			var galleryItem = gridItem.clone();
			if (that.galleryBody.attr('data-limit') == '' || galleryItemsLength < that.galleryBody.attr('data-limit') || that.galleryBody.attr('data-limit') == 1){
				that.galleryEmpty.addClass('hidden');
				that.gallerySelection.removeClass('hidden');
				item.addClass('_07__tile--gallery-selected');
				galleryItem.addClass('handle').find('._07__tile').removeClass('_07__tile--gallery-selector').addClass('_07__tile--gallery-item').prepend('<div class="tile__remove"></div><input type="checkbox" name="media[]" value="'+item.attr('data-id')+'" checked />');
				that.galleryForm.find('.grid').prepend(galleryItem);
			} else {
				$.toaster({
					priority:'warning',
					message:that.galleryBody.attr('data-limit-msg')
				});
			}
		}
		that.addListener();
		if (that.galleryBody.hasClass('_08__body-no-sidebar')){
			that.galleryForm.submit();
		}
	},
	removeItem:function(id){
		var that = this;
		var selectorItem = $('._07__tile--gallery-selector[data-id="'+id+'"]');
		var galleryItem = $('._07__tile--gallery-item[data-id="'+id+'"]');
		var galleryItemsLength = $('._07__tile--gallery-item').length;
		var galleryGridItem = galleryItem.parent();
		that.galleryForm = $('form[name="gallery_selection"]');
		that.galleryBody = $('._08__body');
		that.galleryEmpty = $('._08__empty');
		that.gallerySelection = $('._08__selection');
		selectorItem.removeClass('_07__tile--gallery-selected');
		galleryGridItem.remove();
		if (galleryItemsLength <= 1){
			that.galleryEmpty.removeClass('hidden');
			that.gallerySelection.addClass('hidden');
		}
		that.addListener();
	},
	reinit:function(){
		var that = this;
		that.init();
	}
};
app.modules.gallery = new gallery;
function hint(){
	this.vars = {
		hintQuery:[]
	}
}
hint.prototype = {
	init:function(){
		var that = this;
		that.addListener();

		// check if hint is needed
		if (typeof $('[data-hint]').html() !== 'undefined'){
			that.parseHints();
		}
	},
	addListener:function(){
		var that = this;

		// dismiss hint
		$('.hint .close-hint').unbind().on({
			click:function(){
				var hint = $(this).closest('[data-hint-id]');
				that.dismiss(hint);
			}
		});
	},
	parseHints:function(selector){
		var that = this;
		if (typeof selector !== 'undefined'){
			var hintObjects = $(selector);
		} else {
			var hintObjects = $('[data-hint]:reallyvisible');
		}
		hintObjects.sort(function(a, b){
			return $(a).attr('data-hint-pos')-$(b).attr('data-hint-pos');
		}).each(function(){
			var hint = $(this);
			if (hint.is(':reallyvisible')){
				that.get(hint);
				return false;
			}
		});
	},
	get:function(hint){
		var that = this;
		if ($.inArray(hint.attr('data-hint'), that.vars.hintQuery) == -1){
			that.vars.hintQuery.push(hint.attr('data-hint'));
			$.ajax({
				type:'POST',
				url:$('meta[name="site-url"]').attr('content')+'/events/hint/get/'+hint.attr('data-hint'),
				success:function(data){
					if (data.hint){
						$('.hint').addClass('hint--show').html(data.hint);
						that.position(hint);
						that.addListener();
					} else {
						if (Object.keys(data.left).length > 0){
							$('[data-hint="'+hint.attr('data-hint')+'"]').removeAttr('data-hint');
							that.parseHints();
						}
					}
				}
			});
		}
	},
	dismiss:function(hint){
		var that = this;
		$('.hint').removeClass('hint--show');
		setTimeout(function(){
			$('.hint').empty();
			$.ajax({
				type:'POST',
				url:$('meta[name="site-url"]').attr('content')+'/events/hint/dismiss/'+hint.attr('data-hint-id'),
				success:function(data){
					$('[data-hint="'+hint.attr('data-hint-id')+'"]').removeAttr('data-hint');
					that.parseHints();
				}
			});
		}, 260);
	},
	position:function(hintOrigin){
		var that = this;
		var isFixed = app.elementOrParentIsFixed(hintOrigin);
		var hintWrapper = $('.hint');
		var hint = $('[data-hint-id]');
		var windowWidth = app.getViewport('width');
		var windowHeight = app.getViewport('height');
		var windowScrollTop = $(window).scrollTop();
		var hintOriginWidth = hintOrigin.outerWidth();
		var hintOriginHeight = hintOrigin.outerHeight();
		var hintLeft = hintOrigin.offset().left-23+(hintOriginWidth/2);
		if (isFixed){
			var hintTop = hintOrigin[0].getBoundingClientRect().top;
		} else {
			var hintTop = hintOrigin.offset().top;
		}
		var hintClass = 'hint__content';

		if (isFixed){
			hintWrapper.addClass('hint--fixed');
		} else {
			hintWrapper.removeClass('hint--fixed');
		}

		// override left/right pos
		if (hintLeft+hint.outerWidth() > windowWidth){
			hintClass = 'hint__content hint__content--right';
			hintLeft = hintOrigin.offset().left-hint.outerWidth()+23+(hintOriginWidth/2);
			if (hintOriginWidth > 70) hintLeft = hintOrigin.offset().left-hint.outerWidth()+hintOriginWidth;
		}

		hint.attr('class', hintClass).css({
			top:hintTop+hintOriginHeight+14,
			left:hintLeft
		});

		hintWrapper.css({
			height:$('.site').outerHeight()
		});

		// override top/bottom pos
		if (hintTop+hintOriginHeight+14+hint.outerHeight()-windowScrollTop > windowHeight){
			hint.addClass('hint__content--top').css({
				top:hintTop-14-hint.outerHeight()
			});
		}

		// override left/right pos if width too big
		if (hint.outerWidth() > app.getViewport('width')-20){
			hint.css({
				left:10,
				width:app.getViewport('width')-20,
				'white-space':'inherit'
			});
		}
	}
};
app.modules.hint = new hint;
function authenticate(){
	this.vars = {
		pm:null
	}
}
authenticate.prototype = {
	init:function(){
		var that = this;
		that.addListener();
	},
	addListener:function(){
		var that = this;
		var cardSelector = $('form#authenticate select[name="card"]');

		// select a card
		cardSelector.unbind().on({
			change:function(){
				var card = $(this);
				that.vars.pm = card.val();
				if (card.val() == 'new'){
					window.location.href = intentCreateNewPaymentMethodUrl+'?redirect_url='+window.location.href;
				}
			}
		});

		// handle card payment
		var form = $('form#authenticate');
		if (typeof stripe !== 'undefined' && typeof form.html() !== 'undefined'){
			var showCardsHelper = $('input[name="show_cards"]');
			var authError = [];
			that.vars.pm = intentPaymentMethod;

			// step 1: check if payment method exists in intent
			if (that.vars.pm){
				//
			} else {
				showCardsHelper.val('1');
				app.modules.form.reinit();
			}
			
			// step 2: add click handler to start handleCardPayment process
			var cardButton = document.getElementById('card-button');
			cardButton.addEventListener('click', function(event){
				event.preventDefault();				
				app.modules.form.loading(form, true, true);
				stripe.handleCardPayment(intentClientSecret, {
					payment_method:that.vars.pm
				}).then(function(response){
					app.modules.form.loading(form, false, true);
					if (response.error){
						if (response.error.param == 'payment_method'){
							authError = [stripeMessages.paymentMethod];
						} else {
							authError = [response.error.message];
						}
						app.modules.form.throwError(form, authError);
					} else {
						var successData = {
							msg:stripeMessages.authSuccess
						};
						app.modules.form.success(form, successData, false);
						form.find('.form__row:not(.form__row--msg)').remove();
						$('.button--return-after-success').removeClass('hidden');
					}
				});
			});
		}
	}
};
app.modules.authenticate = new authenticate;
function chart(){
	this.vars = {
		colors:{
			red:'rgb(255, 99, 132)',
			orange:'rgb(255, 159, 64)',
			yellow:'rgb(255, 205, 86)',
			green:'rgb(75, 192, 192)',
			blue:'rgb(54, 162, 235)',
			purple:'rgb(153, 102, 255)',
			grey:'rgb(201, 203, 207)'
		}
	}
}
chart.prototype = {
	init:function(){
		var that = this;
		that.addListener();
	},
	addListener:function(){
		var that = this;
	},
	reinit:function(){
		var that = this;
		that.init();
	}
};
app.modules.chart = new chart;
function cropper(){}
cropper.prototype = {
	init:function(){
		var that = this;
		that.initSelection();
		that.addListener();
	},
	addListener:function(){
		var that = this;
	},
	initSelection:function(){
		var that = this;
		$('.selection__container').each(function(index){
			var swiperObj = $(this);
			var swiperInstance = new Swiper(swiperObj[0], {
				wrapperClass:'selection__wrapper',
				slideClass:'selection__slide',
				spaceBetween:30,
				slideActiveClass:'selection__slide--active',
				slideNextClass:'selection__slide--next',
				slidesPerView:3,
				navigation:{
					nextEl:'.selection__next',
    				prevEl:'.selection__prev',
					disabledClass:'selection__nav--disabled',
					hiddenClass:'selection__nav--hidden'
				},
				allowTouchMove:true,
				breakpoints:{
					1224:{
						slidesPerView:3,
						spaceBetween:30
					},
					1024:{
						slidesPerView:2,
						spaceBetween:20
					},
					768:{
						slidesPerView:1,
						spaceBetween:10
					}
				},
				on:{
					click:function(event){
						var src = $(event.srcElement);
						var slide = src.closest('.selection__slide');
						var image = slide.find('.item__image');
						$('.selection__slide').removeClass('selection__slide--selected');
						slide.addClass('selection__slide--selected');
						that.initCropper(image);
					},
					transitionEnd:function(){
						app.modules.lazyLoad.lazyLoadImages('.cropper__selection [data-bg]');
					}
				}
			});
		});
	},
	initCropper:function(originalImage){
		var that = this,
			url = originalImage.attr('data-original'),
			loading = $('.cropper__loading'),
			actions = $('.cropper__actions'),
			stage = $('.cropper__stage'),
			image = $('.cropper__image'),
			aspectRatio = originalImage.attr('data-aspect-ratio') == 'NaN' ? 'NaN' : originalImage.attr('data-aspect-ratio').split('/'),
			id = originalImage.attr('data-id'),
			size = originalImage.attr('data-size');

		loading.removeClass('cropper__loading--disabled');
		that.destroy(loading, actions, stage, image);

		image.attr('src', url);
		image.cropper({
			aspectRatio:aspectRatio == 'NaN' ? 'NaN' : aspectRatio[0] / aspectRatio[1],
			zoomOnWheel:false,
			crop:function(event){
				//
			}
		});

		var cropper = image.data('cropper');
		setTimeout(function(){
			loading.addClass('cropper__loading--disabled');
			actions.removeClass('cropper__actions--disabled');
			stage.removeClass('cropper__stage--disabled');
			cropper.resize();
		}, 1000);

		$('.button--crop-event').unbind().on({
			click:function(){
				var button = $(this);
				if (!cropper){
					return;
				}

				data = {
					method:button.attr('data-method'),
					option:button.attr('data-option') || undefined,
					secondOption:button.attr('data-second-option') || undefined
				};

				cropped = cropper.cropped;

				if (data.method){
					switch(data.method){
						case 'rotate':
							if (cropped){
								cropper.clear();
							}
							break;
					}

					result = cropper[data.method](data.option, data.secondOption);

					switch(data.method){
						case 'rotate':
							if (cropped){
								cropper.crop();
							}
							break;
					}
				}
			}
		});

		$('.button--crop-image').unbind().on({
			click:function(){
				var button = $(this);
				if (!button.hasClass('button--disabled')){
					button.addClass('button--disabled').append('<span class="loader"></div>');
					var canvas = image.cropper('getCroppedCanvas', {
						imageSmoothingEnabled:true,
						imageSmoothingQuality:'high',
						fillColor:'#fff'
					});
					var canvaURL = canvas.toDataURL('image/jpeg');
					$.ajax({
						type:'POST',
						url:$('meta[name="site-url"]').attr('content')+'/dashboard/cms/media/'+id+'/crop/'+size,
						data:{
							img:canvaURL
						},
						error:function(jqXHR, exception, thrownError){
							button.removeClass('button--disabled');
							button.find('.loader').remove();
							$.toaster({
								priority:'error',
								message:'Error!'
							});
						},
						success:function(data, textStatus, xhr){
							if (data.success === true){
								$.toaster({
									priority:'success',
									message:data.msg
								});
							} else {
								$.toaster({
									priority:'error',
									message:data.msg
								});
							}
							button.removeClass('button--disabled');
							button.find('.loader').remove();
							that.destroy(loading, actions, stage, image);
							$('.selection__slide').removeClass('selection__slide--selected');
							app.modules.lazyLoad.reset('.cropper__selection [data-size="'+data.size+'"]');
							originalImage.attr('data-bg', data.url);
							app.modules.lazyLoad.lazyLoadImages('.cropper__selection [data-size="'+data.size+'"]');
						}
					});
				}
			}
		});
	},
	destroy:function(loading, actions, stage, image){
		var taht = this;
		actions.addClass('cropper__actions--disabled');
		stage.addClass('cropper__stage--disabled');
		image.cropper('destroy');
	},
	reinit:function(){
		var that = this;
		that.initSelection();
	}
};
app.modules.cropper = new cropper;
function search(){
	this.site = $('.site');
	this.autocompleteSearchForm = $('form[id="search"]');
	this.searchQueryField = $('form[id="search"] input[name="q"]');
	this.autocomplete = $('.search_autocomplete');
	this.autocompleteCol = $('.search_autocomplete__col');
	this.autocompleteLeft = $('.search_autocomplete__left');
	this.vars = {
		query:'',
		searchFocus:false,
		autocompleteEnabled:false,
		allowSearch:true
	}
}
search.prototype = {
	init:function(){
		var that = this;
		that.addListener();
	},
	addListener:function(){
		var that = this;

		// autocomplete search
		that.searchQueryField.on({
			focus:function(){
				that.vars.searchFocus = true;
				that.showAutocomplete();
			},
			blur:function(){
				that.vars.searchFocus = false;
			}
		});
		that.searchQueryField.keyup(app.debounce(function(e){
			var formField = $(this);
			var formFieldName = formField.attr('name');
			if (formField.val().length > 2 && e.keyCode != 27){
				if (formField.val() != that.vars.query){
					that.vars.query = $.trim(formField.val());
					if (e.keyCode != 38 && e.keyCode != 40 && that.vars.allowSearch){
						that.autocompleteSearch();
					}
				}
			} else {
				if (e.keyCode != 38 && e.keyCode != 40){
					that.hideAutocomplete();
					that.resetAutocomplete();
				}
			}
			if (e.keyCode == 38 || e.keyCode == 40){
				that.showAutocomplete();
				var optionSelected = $('.autocomplete__list li.selected');
				var optionTarget = optionSelected;
				if (typeof optionSelected.html() === 'undefined'){
					if (e.keyCode == 40){
						optionTarget = $('.search_autocomplete__col:not(.hidden):eq(0) .autocomplete__list:not(.hidden):eq(0) ul li:first-child');
					} else if (e.keyCode == 38){
						optionTarget = $('.search_autocomplete__col:not(.hidden)').eq($('.search_autocomplete__col:not(.hidden)').length-1).find('.autocomplete__list:not(.hidden)').eq($('.search_autocomplete__col:not(.hidden)').eq($('.search_autocomplete__col:not(.hidden)').length-1).find('.autocomplete__list:not(.hidden)').length-1).find('ul li:last-child');
					}
				} else {
					if (e.keyCode == 40){
						optionTarget = optionTarget.next();
						if (optionTarget.length == 0){
							var optionList = optionSelected.closest('.autocomplete__list');
							var newOptionList = optionList.next(':not(.hidden)');
							if (newOptionList.length == 0){
								var optionCol = optionSelected.closest('.search_autocomplete__col');
								var newOptionCol = optionCol.next(':not(.hidden)');
								if (newOptionCol.length == 0){
									// start
								} else {
									optionTarget = newOptionCol.find('.autocomplete__list:not(.hidden) ul li:first-child');
									if (optionTarget.length == 0){
										// start
									}
								}
							} else {
								optionTarget = newOptionList.find('ul li:first-child');
							}
						}
					} else if (e.keyCode == 38){
						optionTarget = optionTarget.prev();
						if (optionTarget.length == 0){
							var optionList = optionSelected.closest('.autocomplete__list');
							var newOptionList = optionList.prev(':not(.hidden)');
							if (newOptionList.length == 0){
								var optionCol = optionSelected.closest('.search_autocomplete__col');
								var newOptionCol = optionCol.prev(':not(.hidden)');
								if (newOptionCol.length == 0){
									// start
								} else {
									optionTarget = newOptionCol.find('.autocomplete__list:not(.hidden):eq('+(newOptionCol.find('.autocomplete__list:not(.hidden)').length-1)+') ul li:last-child');
									if (optionTarget.length == 0){
										// start
									}
								}
							} else {
								optionTarget = newOptionList.find('ul li:last-child');
							}
						}
					}
					optionSelected.removeClass('selected');
				}
				optionTarget.focus().addClass('selected');
				formField.val(optionTarget.find('a').text());
			}
		}, 50));
		that.autocomplete.unbind().on({
			clickoutside:function(){
				if (that.vars.searchFocus !== true){
					that.hideAutocomplete();
				}
			}
		});
		$(document).keyup(function(e){
			if (e.keyCode == 27) {
				if (that.site.hasClass('site--search-autocomplete')){
					that.hideAutocomplete();
				}
			}
		});
		$(document).on({
			keyup:function(e){
				if (e.keyCode == 27) {
					if (that.site.hasClass('site--search-autocomplete')){
						that.hideAutocomplete();
					}
				}
			},
			scroll:function(){
				that.repositionAutocomplete();
			}
		});

		// submit autocomplete form
		that.autocompleteSearchForm.unbind().on({
			submit:function(e){
				e.preventDefault();
  				e.stopImmediatePropagation();
				that.submitForm(false);
				return false;
			}
		});
	},
	showAutocomplete:function(){
		var that = this;
		if (that.vars.autocompleteEnabled){
			that.site.addClass('site--search-autocomplete');
		}
	},
	hideAutocomplete:function(){
		var that = this;
		that.site.removeClass('site--search-autocomplete');
	},
	resetAutocomplete:function(){
		var that = this;
		that.vars.autocompleteEnabled = false;
		that.autocomplete.removeAttr('style').find('.autocomplete__list ul, #autocomplete__query').empty();
	},
	repositionAutocomplete:function(){
		var that = this;
		if (typeof that.autocomplete.html() !== 'undefined' && typeof that.autocompleteSearchForm.html() !== 'undefined'){
			that.autocomplete.css({
				left:that.autocompleteSearchForm.offset().left,
				top:that.autocompleteSearchForm.offset().top+that.autocompleteSearchForm.outerHeight(),
				width:that.autocompleteSearchForm.outerWidth()
			});
		}
	},
	resize:function(){
		var that = this;
		that.repositionAutocomplete();
	},
	submitForm:function(force){
		var that = this;
		if (that.autocomplete.find('li.selected').length > 0){
			window.location.href = that.autocomplete.find('li.selected a').attr('href');
			that.vars.autocompleteEnabled = false;
			that.vars.allowSearch = false;
			that.hideAutocomplete();
		}
		return false;
	},
	autocompleteSearch:function(){
		var that = this;
		$.ajax({
			type:'POST',
			url:$('meta[name="site-url"]').attr('content')+'/dashboard/events/search/suggest',
			data:that.autocompleteSearchForm.serialize(),
			success:function(data){
				that.vars.autocompleteEnabled = true;

				// pages
				var resultListHtml = '';
				var listObj = that.autocomplete.find('.autocomplete__list--pages');
				if (typeof data.hits_pages !== 'undefined'){
					$.each(data.hits_pages.hits, function(key, item){
						var itemName = item._source.name;
						var itemNameField = 'name';
						if (typeof item.highlight !== 'undefined'){
							itemName = item.highlight[itemNameField];
						}
						resultListHtml += '<li><a href="'+$('meta[name="site-url"]').attr('content')+'/dashboard/cms/pages/'+item._source.id+'/edit" data-type="pages" data-id="'+item._source.id+'"><span>'+itemName+'</span>';
						resultListHtml += '</a></li>';
					});
					if (data.hits_pages.total.value == 0){
						resultListHtml += '<li><em>'+data.message_no_results+'</em></li>';
						listObj.addClass('hidden');
					} else {
						listObj.removeClass('hidden');
					}
					listObj.find('ul').html(resultListHtml);
				}

				// system pages
				var resultListHtml = '';
				var listObj = that.autocomplete.find('.autocomplete__list--system');
				if (typeof data.hits_system !== 'undefined'){
					$.each(data.hits_system.hits, function(key, item){
						var itemName = item._source.name;
						var itemNameField = 'name';
						if (typeof item.highlight !== 'undefined'){
							itemName = item.highlight[itemNameField];
						}
						resultListHtml += '<li><a href="'+$('meta[name="site-url"]').attr('content')+'/dashboard/events/system-route/redirect?route='+item._source.route+'" data-type="system" data-id="'+item._source.id+'"><span>'+itemName+'</span>';
						resultListHtml += '</a></li>';
					});
					if (data.hits_system.total.value == 0){
						resultListHtml += '<li><em>'+data.message_no_results+'</em></li>';
						listObj.addClass('hidden');
					} else {
						listObj.removeClass('hidden');
					}
					listObj.find('ul').html(resultListHtml);
				}

				// left side
				if (data.hits_pages.total.value == 0 && data.hits_system.total.value == 0){
					that.autocompleteLeft.addClass('hidden');
				} else {
					that.autocompleteLeft.removeClass('hidden');
				}

				// show autocomplete
				if (data.hits_pages.total.value == 0 && data.hits_system.total.value == 0){
					that.hideAutocomplete();
				} else {
					that.site.addClass('site--search-autocomplete');
					that.autocomplete.css({
						left:that.autocompleteSearchForm.offset().left,
						top:that.autocompleteSearchForm.offset().top+that.autocompleteSearchForm.outerHeight(),
						width:that.autocompleteSearchForm.outerWidth()
					});
					that.site.append(that.autocomplete);
				}

				// reinit options addlistener
				that.optionsAddListener();
			}
		});
	},
	optionsAddListener:function(){
		var that = this;
	},
	reinit:function(){
		var that = this;
		that.init();
	}
};
app.modules.search = new search;
function ace(){}
ace.prototype = {
	init:function(){
		var that = this;
		that.addListener();

		// init ace
		if (typeof $('.ace_editor').html() !== 'undefined' && typeof ace !== 'undefined'){
			var acePath = $('meta[name="site-url"]').attr('content')+'/assets/vendor/ace';
			$.getScript(acePath+'/ace.js', function(data, textStatus, jqxhr){
				ace.config.set('basePath', acePath);
				$('.ace_editor').each(function(index){
					var aceEditorContainer = $(this);
					var aceEditor = aceEditorContainer.find('.ace_editor__inner');
					var textarea = aceEditor.next('textarea');
					aceEditor.attr('id', 'ace-editor-'+index);
					if (typeof $('.ace_editor__inner[id="ace-editor-'+index+'"]').html() !== 'undefined'){
						var editor = ace.edit('ace-editor-'+index, {
					        mode:'ace/mode/'+aceEditor.attr('data-mode'),
					        minLines:10,
					        maxLines:40,
					        wrap:false,
					        autoScrollEditorIntoView:true
					    });
					    editor.getSession().on('change', function(){
					    	textarea.val(editor.getSession().getValue());
					    });
					}
				});
			});
		}
	},
	addListener:function(){
		var that = this;
	},
	resizeEditor:function(){
		var that = this;
		if (typeof $('.ace_editor').html() !== 'undefined' && typeof ace !== 'undefined'){
			$('.ace_editor').each(function(index){
				var aceEditorContainer = $(this);
				if (typeof $('.ace_editor__inner[id="ace-editor-'+index+'"]').html() !== 'undefined'){
					var editor = ace.edit('ace-editor-'+index);
					editor.resize(true);
				}
			});
		}
	},
	reinit:function(){
		var that = this;
		that.init();
	}
};
app.modules.ace = new ace;
function media(){
	this.folderContainer = $('#folder-tiles');
}
media.prototype = {
	init:function(){
		var that = this;
		that.addListener();
	},
	addListener:function(){
		var that = this;
	},
	folderCreated:function(form, data){
		var that = this;
		that.folderContainer.prepend(data.html);
		form[0].reset();
		app.modules.overlay.hideIfOpen();
		app.modules.overlay.reinit();
	},
	folderDeleted:function(button, data){
		var that = this;
		that.folderContainer.find('[data-id="'+data.id+'"]').remove();
		app.modules.overlay.hideIfOpen();
	},
	folderUpdated:function(button, data){
		var that = this;
		var folderItem = that.folderContainer.find('[data-id="'+data.id+'"]');
		folderItem.find('.item__name').text(data.name);
		if (folderItem.attr('data-parent') != data.parent){
			folderItem.remove();
		}
		app.modules.overlay.hideIfOpen();
	}
};
app.modules.media = new media;
function appSocialhub(){}
appSocialhub.prototype = {
	init:function(){
		var that = this;
		that.addListener();
	},
	addListener:function(){
		var that = this;
	},
	toggleStatus:function(button, data){
		var that = this;
		$('.badge[data-status="'+data.id+'"]').attr('class', data.badgeClass).html(data.badgeHtml);
		$('[data-toggle-button="'+data.id+'"][data-toggle-button-type="toggle"]').removeClass('hidden').html(data.button);
		$('[data-toggle-button="'+data.id+'"][data-toggle-button-type="manually"]').remove();
		$('[data-toggle-li="'+data.id+'"][data-toggle-li-type="toggle"]').removeClass('hidden').find('a').html(data.button);
		$('[data-toggle-li="'+data.id+'"][data-toggle-li-type="manually"]').remove();
	}
};
app.modules.appSocialhub = new appSocialhub;